// import React, { useEffect, useState } from "react";
// import Layout, { Container } from "../components/layout.js";
// import { Link, NavLink, useNavigate } from "react-router-dom";
// import Chart from "chart.js/auto";
// import { LiaLongArrowAltRightSolid } from "react-icons/lia";
// import { Doughnut, Line, Pie, Bar } from "react-chartjs-2";
// import { BsClockHistory } from "react-icons/bs";
// import { FaUsers } from "react-icons/fa";
// import { CiUser } from "react-icons/ci";
// import { PiFilePdfLight } from "react-icons/pi";
// import { FiSearch } from "react-icons/fi";
// import { useUser } from "../config/userProvider.js";
// import { BiCloset } from "react-icons/bi";
// import { IoClose } from "react-icons/io5";
// import axios from "axios";
// import { getCookie } from "../config/webStorage.js";
// import { apiurl } from "../config/config.js";
// import NoInternetConnection from "../components/noInternetConnection";
// import { GoDot } from "react-icons/go";
// import { FaCheck } from "react-icons/fa6";
// import { BlackButton } from "../components/buttonContainer.js";
// import { AiOutlineUpload } from "react-icons/ai";
// import { motion } from "framer-motion";
// import { useTheme } from "../config/themeContext.js";

// const Dashboard = () => {

//   const {
//     userData,
//     storeData,
//     getstoresLoading,
//     setCloseProfile,
//     permissions,
//     showSearch,
//     setShowSearch,
//   } = useUser();
//   let vendorObjId = userData?.vendorDetails?.vendorObjId;
//   let storeObjId = userData?.storeDetails?.storeObjId;

//   const token = getCookie("bb_token");
//   const [searchInput, setSearchInput] = useState("");
//   const [pieData, setPieData] = useState("");
//   const [dashboardData, setDashboardData] = useState("");
//   const [analyticsData, setAnalyticsData] = useState("");
//   const [userType, setUserType] = useState(userData?.userType);

//   const [loadingData, setLoadingData] = useState(false);
//   const data = {
//     labels: ["week 1", "week 2", "week 3", "week 4"],
//     datasets: [
//       {
//         label: "First dataset",
//         data: "",
//         fill: true,
//         tension: 0.2,
//         backgroundColor: "rgba(75,192,192,0.2)",
//         borderColor: "rgba(75,192,192,1)",
//       },
//     ],
//   };
//   const LineData = {
//     labels: [
//       "orders",
//       "Catalog Generated",
//       "catalog downloaded",
//       "send on whatsapp",
//       "shared",
//     ],

//     datasets: [
//       {
//         label: "today",
//         data: [
//           analyticsData?.todayReport?.order_placed,
//           analyticsData?.todayReport?.catalog_generated,
//           analyticsData?.todayReport?.catalog_downloaded,
//           analyticsData?.todayReport?.catalog_sent_whatsapp,
//           analyticsData?.todayReport?.catalog_sent_email,
//         ],
//         fill: true,
//         tension: 0.2,
//         // backgroundColor: "rgba(235, 235, 235,0.2)",
//         // borderColor: "rgba(235, 235, 235,1)",
//         backgroundColor: "#d3c2e2",
//         // borderColor: "rgba(75,192,192,1)",
//       },
//       {
//         label: "30 days",
//         data: [
//           analyticsData?.last30DaysReport?.order_placed,
//           analyticsData?.last30DaysReport?.catalog_generated,
//           analyticsData?.last30DaysReport?.catalog_downloaded,
//           analyticsData?.last30DaysReport?.catalog_sent_whatsapp,
//           analyticsData?.last30DaysReport?.catalog_sent_email,
//         ],
//         fill: true,
//         tension: 0.2,
//         // backgroundColor: "rgba(235, 235, 235,0.2)",
//         // borderColor: "rgba(235, 235, 235,1)",
//         backgroundColor: "rgba(75,192,192,0.2)",
//         // borderColor: "rgba(75,192,192,1)",
//       },
//     ],
//   };

//   const [SearchParam] = ["storecode,Address,storename"];
//   const [isOpenSearch, setIsOpenSearch] = useState(false);

//   const PieData = {
//     labels: ["Inactive User", "Active Users"],
//     datasets: [
//       loadingData
//         ? {
//             label: "loading data",
//             data: [
//               {},
//               {},
//               // dashboardData?,
//             ],
//             backgroundColor: ["rgb(255,225,225,1)", "rgb(225,225,225,0.3)"],
//             hoverOffset: 2,
//           }
//         : {
//             label: ["inactive users", "active users"],
//             data: [
//               analyticsData?.vendorData?.users-analyticsData?.vendorData?.activeUsers,
//               analyticsData?.vendorData?.activeUsers,
//               // dashboardData?,
//             ],
//             backgroundColor: ["rgb(255, 99, 132)", "rgb(54, 162, 235)"],
//             hoverOffset: 2,
//           },
//     ],
//   };

//   useEffect(() => {
//     setLoadingData(true);

//     const Url =
//       userType === "superadmin"
//         ? `${apiurl}/admin/v1/analytic/report/dashboard/superadmin/all`
//         : userType === "admin"
//         ? `${apiurl}/admin/v1/analytic/report/dashboard/store`
//         : userType === "user"
//         ? `${apiurl}/admin/v1/analytic/report/dashboard/user`
//         : "";
//     if (Url) {
//       let data = JSON.stringify({
//         vendorObjId: vendorObjId,
//         storeObjId: storeObjId,
//         userObjId: userData._id,
//       });

//       let config = {
//         method: "post",
//         maxBodyLength: Infinity,
//         url: Url,
//         headers: {
//           "Content-Type": "application/json",
//         },
//         data: data,
//       };

//       axios
//         .request(config)
//         .then((response) => {
//           console.log(JSON.stringify(response.data));
//           if (response.data.success === true) {
//             setLoadingData(false);
//             setAnalyticsData(response.data.data);
//           }
//         })
//         .catch((error) => {
//           console.log(error);
//           setLoadingData(false);
//         });
//     }
//   }, []);

//   return (
//     <Layout>
//       {userType && userType === "master" ? (
//         <MasterDashboard />
//       ) : (
//         <CommonDashboard
//           LineData={LineData}
//           PieData={PieData}
//           permissions={permissions}
//           analyticsData={analyticsData}
//           userData={userData}
//           isOpenSearch={isOpenSearch}
//           searchInput={searchInput}
//           setSearchInput={setSearchInput}
//           setIsOpenSearch={setIsOpenSearch}
//           setShowSearch={setShowSearch}
//           userType={userType}
//         />
//       )}
//     </Layout>
//   );
// };

// export default Dashboard;

// // ================    MASTER DASHBOARD =================

// const MasterDashboard = () => {
//   let navigate = useNavigate();
//   const [loader, setLoader] = useState(false);
//   const [reportData, setReportData] = useState({});
//   let { userData } = useUser();
//   let token = getCookie("sctoken");

//   useEffect(() => {
//     setLoader(true);
//     let config = {
//       method: "get",
//       maxBodyLength: Infinity,
//       url: `${apiurl}/admin/v1/dashboard/master/report`,
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: token,
//       },
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         if (response.data.success === true) {
//           setReportData(response.data.data);
//         }
//         setLoader(false);
//       })
//       .catch((error) => {
//         console.log(error);
//         setLoader(false);
//       });
//   }, []);

//   // const goVendorDetails = (id) => {
//   //   navigate(`/vendors/${id}`);
//   // };
//   return (
//     <Container overflow={"overflow-scroll"}>
//       <div className="min-h-screen bg-gray-100 p-6">
//         <div className="bg-gray-100 pb-6">
//           <StatsSection counts={reportData?.counts} />
//         </div>
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//           <div className="col-span-2 bg-white rounded-lg shadow p-6">
//             <BestSellingProductsTable
//               vendors={reportData?.allRecords?.vendors}
//             />
//           </div>
//           <div className="bg-white rounded-lg shadow p-6">
//             <PopularClientsTable />
//           </div>
//           <div className="bg-white rounded-lg shadow p-6">
//             {/* <OrderOverviewChart /> */}
//           </div>
//         </div>
//       </div>
//     </Container>
//   );
// };

// // ================    CommonDashboard DASHBOARD =================

// const CommonDashboard = ({
//   LineData,
//   PieData,
//   permissions,
//   analyticsData,
//   userData,
//   isOpenSearch,
//   searchInput,
//   setSearchInput,
//   setIsOpenSearch,
//   setShowSearch,
//   userType,
// }) => {
//   return (
//     <>
//       <div className="relative overflow-y-scroll h-full">
//         <div className="flex flex-col items-start justify-between gap-1 w-full p-1 rounded-lg">
//           <div className="w-full">
//             <div className="flex w-full">
//               <Dashboard1
//                 LineData={LineData}
//                 PieData={PieData}
//                 permissions={permissions}
//                 analyticsData={analyticsData}
//                 userData={userData}
//                 userType={userType}
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//       {isOpenSearch && (
//         <div className="w-full md:w-2/3 h-[80%] shadow z-30 top-1/2 left-1/2 transform translate-x-[-50%] translate-y-[-50%] pb-2 bg-white/100 absolute rounded-xl flex flex-col gap-3 overflow-hidden">
//           <div className="flex w-full items-center justify-between gap-5 px-4 md:px-10 mt-3">
//             <div className="flex items-center py-1 px-2 rounded-xl w-full bg-white/100 border">
//               <FiSearch />
//               <input
//                 type="text"
//                 placeholder="search here..."
//                 className="outline-none w-full px-2"
//                 value={searchInput}
//                 onChange={(e) => setSearchInput(e.target.value)}
//               />
//             </div>
//             <div
//               className="border p-1 rounded-lg cursor-pointer"
//               onClick={() => setIsOpenSearch(false)}
//             >
//               <IoClose />
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// // ================  =================   =================    =================    =================   =================

// const CardContainer = ({ children, imgSrc, to }) => (
//   <NavLink
//     className="shadow-sm rounded-lg p-2 lg:p-3 flex gap-0.5 lg:gap-2 items-center bg-white/100"
//     to={to}
//   >
//     <img className="h-4 lg:h-7" src={imgSrc} alt="" />
//     <h2 className="text-xs lg:text-base">{children}</h2>
//   </NavLink>
// );

// const AnalyticsCardContainer = ({
//   label,
//   value,
//   icon,
//   IconBackgroundColor,
//   className,
//   loadingData,
// }) => (
//   <div
//     className={`shadow-sm bg-white/100 m-1 rounded-lg md:p-4 p-3 py-3 flex flex-col w-[46.5%] md:w-[24%] ${className}`}
//   >
//     <div className="flex gap-1 items-center whitespace-pre">
//       <div
//         className={`${IconBackgroundColor} p-1 rounded-lg md:text-base text-xs`}
//       >
//         {icon}
//       </div>
//       <p className="font-medium text-[0.65rem] md:text-sm">{label}</p>
//     </div>
//     {loadingData ? (
//       <Loading_Card />
//     ) : (
//       <h1 className="font-semibold text-2xl lg:text-5xl text-end">{value}</h1>
//     )}
//   </div>
// );

// const Loading_Card = ({ lines, className, ContainerclassName }) => (
//   <div
//     role="status"
//     className={`max-w-full animate-pulse mt-2 ${ContainerclassName}`}
//   >
//     <div
//       className={`h-full bg-gray-200 rounded-lg w-full mb-4 ${className}`}
//     ></div>
//   </div>
// );

// const Dashboard1 = ({
//   LineData,
//   PieData,
//   permissions,
//   analyticsData,
//   userData,
//   userType,
// }) => {
//   const [isVerified, setIsVerified] = useState({
//     email: userData?.verificationDetails?.isEmailVerified,
//     phone: userData?.verificationDetails?.isPhoneVerified,
//     store: userData?.storeDetails?.storeObjId,
//   });

//   const verificationDetails = userData?.verificationDetails;
//   const isEmailVerified = verificationDetails?.isEmailVerified;
//   const isPhoneVerified = verificationDetails?.isPhoneVerified;
//   const isStoreVerified = userData?.storeDetails?.storeObjId;

//   const { vendor} = useTheme();
//   console.log("vendor 174",vendor);

//   useEffect(() => {
//     if (userData.userType === "superadmin") {
//       if (!isEmailVerified && !isPhoneVerified) {
//         setIsVerified({ email: false, phone: false });
//       } else if (isEmailVerified && !isPhoneVerified) {
//         setIsVerified({ email: true, phone: false });
//       } else if (!isEmailVerified && isPhoneVerified) {
//         setIsVerified({ email: false, phone: true });
//       } else if (isEmailVerified && isPhoneVerified) {
//         setIsVerified({ email: true, phone: true });
//       }
//     }
//   }, [userData, verificationDetails]);

//   console.log("userData", userData);

//   const storeVerified =
//     userData.userType === "admin" || userData.userType === "user"
//       ? !isVerified.store
//       : null;

//   const [verifyPopUp, setVerifyPopUp] = useState(
//     !isVerified.email || !isVerified.phone || storeVerified
//   );
//   const [vendorLogo, setVendorLogo] = useState(vendor?.vendorDetails?.log?.upload);

//   const labels = Array.from({ length: 30 }, (_, i) => {
//     const date = new Date();
//     date.setDate(date.getDate() - (29 - i)); // Start from 29 days ago to today
//     return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); // Format as "MMM DD"
//   });

//   // Simulated data for the last 30 days (replace these with real data from your database or API)
//   const generateRandomData = () => Array.from({ length: 30 }, () => Math.floor(Math.random() * 100) + 10);

//   const LineChartdata = {
//     labels: labels,
//     datasets: [
//       // {
//       //   label: 'Orders',
//       //  data: [65, 59, 80, 81, 56, 55, 11,34,34,65,76,86,52,23,13,44,40, 65, 59, 80, 81, 56, 55, 40, 65, 59, 80, 81, 56, 22],
//       //   fill: false,
//       //   borderColor: 'rgb(75, 192, 192)',
//       //   tension: 0.1,
//       // },
//       // {
//       //   label: 'Generated Orders',
//       //   data: generateRandomData(),
//       //   fill: false,
//       //   borderColor: 'rgb(255, 99, 132)',
//       //   tension: 0.1,
//       // },
//       // {
//       //   label: 'Shared via WhatsApp',
//       //   data: generateRandomData(),
//       //   fill: false,
//       //   borderColor: 'rgb(54, 162, 235)',
//       //   tension: 0.1,
//       // },
//       // {
//       //   label: 'Shared via Email',
//       //   data: generateRandomData(),
//       //   fill: false,
//       //   borderColor: 'rgb(153, 102, 255)',
//       //   tension: 0.1,
//       // },
//       {
//         label: 'Shared',
//         data: generateRandomData(),
//         fill: false,
//         borderColor: 'rgb(255, 206, 86)',
//         tension: 0.1,
//       },
//     ],
//   };

//   return (
//     <div className="pb-6 md:py-0 w-full">
//       {/* {verifyPopUp !== null && (
//         <motion.div
//           initial={{ opacity: 0, y: -20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.3 }}
//           className="bg-white text-sm shadow border border-red-300 py-2 px-4 rounded-lg mb-1 relative"
//         >
//           <button
//             className="absolute right-1 top-1"
//             onClick={() => setVerifyPopUp(null)}
//           >
//             <IoClose />
//           </button>

//           <div className="flex justify-between items-center align-middle">
//             <div>
//               {isVerified.email === true ? (
//                 <span className="text-green-600 flex items-center">
//                   <FaCheck className="mr-2" />
//                   Email is Verified
//                 </span>
//               ) : (
//                 <div className="flex items-center justify-between">
//                   <span className="text-red-500 flex items-center">
//                     <IoClose className="mr-2" />
//                     Email is not verified
//                   </span>
//                 </div>
//               )}

//               {isVerified.phone === true ? (
//                 <span className="text-green-600 flex items-center">
//                   <FaCheck className="mr-2" />
//                   Phone number is Verified
//                 </span>
//               ) : (
//                 <span className="text-red-500 flex items-center">
//                   <IoClose className="mr-2" />
//                   Phone number is not verified
//                 </span>
//               )}

//               {userData.userType === "admin" || userData.userType === "user" ? (
//                 isVerified.store === true ? (
//                   <span className="text-green-600 flex items-center">
//                     <FaCheck className="mr-2" />
//                     Store is Verified
//                   </span>
//                 ) : (
//                   <span className="text-red-500 flex items-center">
//                     <IoClose className="mr-2" />
//                     You have not assigned with any Store
//                   </span>
//                 )
//               ) : (
//                 ""
//               )}
//             </div>
//             <div>
//               <div className="md:mr-5">
//                 <Link to="/account">
//                   <button className="text-red-400 border border-red-400 px-3 py-1 rounded-sm">
//                     Verify
//                   </button>
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </motion.div>
//       )} */}
//       {vendorLogo === false && userType === "superadmin" && (
//         <motion.div
//           initial={{ opacity: 0, y: -20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.5 }}
//           className="bg-white shadow border text-sm border-red-300 py-2 px-4 rounded-lg mb-1 relative"
//         >
//           <button
//             className="absolute right-1 top-1"
//             onClick={() => setVendorLogo(false)}
//           >
//             <IoClose />
//           </button>
//           {vendor?.vendorDetails?.log?.upload === false ? (
//             <div className="flex items-center justify-between">
//               <span className="text-red-500 flex items-center">
//                 <IoClose className="mr-2" />
//                 Logo is Mandatory, Please Upload Logo First
//               </span>
//               <div className="md:mr-5">
//                 <Link to="/settings/documents">
//                   <button className="text-red-400 border text-sm border-red-400 px-3 py-1 rounded-sm">
//                     {/* <AiOutlineUpload /> */}Upload
//                   </button>
//                 </Link>
//               </div>
//             </div>
//           ) : null}
//         </motion.div>
//       )}

//       <div className="flex flex-col items-start md:flex-row w-full gap-2">
//         <div className="w-full md:w-1/3  flex flex-col gap-2">
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.2, delay: 0.2 }}
//             className="bg-white rounded-lg shadow p-4 md:p-6 "
//           >
//             <h2 className="text-lg md:text-2xl font-semibold">
//               Today's Orders
//             </h2>
//             <div className="flex items-center space-x-4 ">
//               <h3 className="text-2xl md:text-4xl font-bold">22</h3>
//               <p
//                 className={`text-base md:text-lg font-semibold ${
//                   24 < 1 ? "text-red-500" : "text-green-500"
//                 }`}
//               >
//                 24.00%
//               </p>
//             </div>
//             <p className="text-sm text-gray-500">
//               {22 < 1
//                 ? "You have a low performance 👎"
//                 : "You have a great performance 👍"}
//             </p>
//             <div className="mt-6 flex flex-col gap-4">
//               <StatCard
//                 label="Total Revenue"
//                 value={analyticsData?.vendorData?.revenue || "0"}
//                 color="#b5f0d5"
//                 className="border-green-300"
//               />
//               <StatCard
//                 label="Generated"
//                 value={analyticsData?.todayReport?.catalog_generated}
//                 color="#E9CFFC"
//               />
//               <StatCard
//                 label="Shared"
//                 value={analyticsData?.todayReport?.catalog_downloaded}
//                 color="#f4eeee"
//               />
//               <StatCard
//                 label="send on whatsapp"
//                 value={analyticsData?.todayReport?.catalog_sent_whatsapp}
//                 color="#D0C2E3"
//               />
//               <StatCard
//                 label="send on mail"
//                 value={analyticsData?.todayReport?.catalog_sent_email}
//                 color="#E9CFFC"
//               />
//             </div>
//           </motion.div>

//           {userType !== "user" && userType !== "admin" && (
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.5 }}
//               className="shadow  rounded-lg h-auto p-2  bg-white/100 "
//             >
//               <Doughnut data={PieData} />
//             </motion.div>
//           )}
//         </div>

//         <div className="w-full md:w-2/3  flex flex-col gap-2">
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.3, delay: 0.3 }}
//             className="flex flex-col bg-white rounded-lg shadow p-4 md:p-6  "
//           >
//             <h2 className="md:text-lg text-sm font-semibold mb-4">
//               Last 30 Days Data
//             </h2>
//             <AnalyticsDashboard
//               analyticsData={analyticsData}
//               userType={userType}
//             />
//           </motion.div>

//           {userType !== "user" && userType !== "admin" && (
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.4, delay: 0.4 }}
//               className={`shadow rounded-lg w-full bg-white/100 p-3 py-6`}
//             >
//               {/* <Bar data={LineData} style={{ height: "auto", width: "100%" }} /> */}
//               <Line data={LineData} style={{ height: "auto", width: "100%" }} />
//             </motion.div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// // Helper Components
// const StatCard = ({ label, value, onClick, color, className }) => (
//   <div
//     className={`text-center w-full border rounded-xl cursor-pointer flex justify-between items-center px-3 py-3 ${className}`}
//     onClick={onClick}
//   >
//     <p className="text-sm md:text-base font-semibold flex items-center gap-2  capitalize">
//       <GoDot />
//       {label}
//     </p>
//     <p
//       className={` font-semibold text-gray-800 px-5 rounded-full text-xs md:text-sm`}
//       style={{ backgroundColor: color }}
//     >
//       {value}
//     </p>
//   </div>
// );

// const TokenAllocation = ({ name, value }) => (
//   <div className="p-3 md:p-4 bg-gray-100 rounded-md text-center">
//     <p className="text-base md:text-lg font-semibold text-gray-800">{name}</p>
//     <p className="text-sm md:text-base text-gray-500">{value}</p>
//   </div>
// );

// const PortfolioRow = ({
//   asset,
//   symbol,
//   balance,
//   avgBuyPrice,
//   profitLoss,
//   value,
//   isProfit,
// }) => (
//   <div className="flex flex-col md:grid md:grid-cols-5 gap-2 md:gap-4 py-4 border-b last:border-b-0  overflow-auto">
//     <div className="flex items-center space-x-3">
//       <div className="font-bold text-sm md:text-base">{asset}</div>
//       <p className="text-xs text-gray-400">{symbol}</p>
//     </div>
//     <div className="text-sm md:text-base text-gray-700">{balance}</div>
//     <div className="text-sm md:text-base text-gray-700">{avgBuyPrice}</div>
//     <div
//       className={`text-sm md:text-base font-semibold ${
//         isProfit ? "text-green-500" : "text-red-500"
//       }`}
//     >
//       {profitLoss}
//     </div>
//     <div className="text-sm md:text-base text-gray-700">{value}</div>
//   </div>
// );

// const RetentionGrid = () => (
//   <div className="grid grid-cols-3 md:grid-cols-7 gap-2 mt-4 text-center">
//     {["Jan", "Feb", "Mar", "Apr", "May", "Jun"].map((month, index) => (
//       <div
//         key={index}
//         className="p-2 bg-blue-100 text-blue-800 rounded-lg text-xs md:text-sm"
//       >
//         {month}
//       </div>
//     ))}
//   </div>
// );

// // export default Dashboard;

// const StoreDetails = ({
//   title,
//   value,
//   icon,
//   bgColor = "bg-purple-100",
//   textColor = "text-green-500",
// }) => {
//   return (
//     <div className={`${bgColor} rounded-lg p-4`}>
//       <div className="flex justify-between items-center md:text-base text-xs">
//         <span className="font-medium capitalize ">{title}</span>
//         {icon ? (
//           <span
//             className={`text-xl bg-white rounded-full w-7 h-7 flex justify-center items-center ${
//               icon === "↑" ? "text-green-700" : "text-red-600"
//             }`}
//           >
//             {icon === "↑" ? "↑" : "↓"}
//           </span>
//         ) : (
//           <span
//             className={`text-xl bg-white rounded-full w-7 h-7 flex justify-center items-center ${
//               value > 0 ? "text-green-700" : "text-red-600"
//             }`}
//           >
//             {value > 0 ? "↑" : "↓"}
//           </span>
//         )}
//       </div>
//       <div className="text-lg font-semibold ">{value}</div>
//     </div>
//   );
// };

// const AnalyticsDashboard = ({ analyticsData, userType }) => {
//   return (
//     <div className="grid md:grid-cols-3 grid-cols-2 gap-4">
//       <StoreDetails
//         title="Orders"
//         value={analyticsData?.vendorData?.order_placed || "0"}
//         // icon={analyticsData?.todayReport?.catalog_generated > 0 ? "↑" : "↓"}
//         bgColor="bg-[#E9CFFC]"
//         textColor="text-green-500"
//       />
//       {userType !== "user" && (
//         <StoreDetails
//           title="Users"
//           value={analyticsData?.vendorData?.users || "0"}
//           // icon={analyticsData?.totalUsers > 0 ? "↑" : "↓"}
//           bgColor="bg-[#D0C2E3]"
//           textColor="text-red-500"
//         />
//       )}
//       <StoreDetails
//         title="Revenue"
//         value={analyticsData?.vendorData?.revenue || "0"}
//         icon="↑"
//         bgColor="bg-[#C6E3F3]"
//         textColor="text-green-500"
//       />

//       <StoreDetails
//         title="Catalog Generated"
//         value={analyticsData?.vendorData?.catalog_generated || "0"}
//         // icon="↑"
//         bgColor="bg-[#FFFDC7]"
//         textColor="text-green-500"
//       />
//       {userType !== "user" && userType !== "admin" && (
//         <StoreDetails
//           title="Active Users"
//           value={analyticsData?.vendorData?.activeUsers || "0"}
//           // icon="↑"
//           bgColor="bg-[#E9CFFC]"
//           textColor="text-green-500"
//         />
//       )}
//       <StoreDetails
//         title="WhatsApp"
//         value={analyticsData?.vendorData?.catalog_sent_whatsapp || "0"}
//         // icon="↑"
//         bgColor="bg-[#C3EFD3]"
//         textColor="text-green-500"
//       />

//       <StoreDetails
//         title="Catalog Shared"
//         value={analyticsData?.vendorData?.catalog_downloaded || "0"}
//         // icon={analyticsData?.todayReport?.catalog_downloaded > 0 ? "↑" : "↓"}
//         bgColor="bg-[#C6E3F3]"
//         textColor="text-green-500"
//       />
//       {userType === "user" && (
//         <StoreDetails
//           title="Catalog sent"
//           value={analyticsData?.last30DaysReport?.catalog_downloaded || "0"}
//           // icon={analyticsData?.todayReport?.catalog_downloaded > 0 ? "↑" : "↓"}
//           bgColor="bg-[#ff20f350]"
//           textColor="text-green-500"
//         />
//       )}
//       {userType !== "user" && userType !== "admin" && (
//         <StoreDetails
//           title="Stores"
//           value={analyticsData?.vendorData?.stores || "0"}
//           // icon="↑"
//           bgColor="bg-[#C3EFD3]"
//           textColor="text-green-500"
//         />
//       )}
//       {userType !== "user" && userType !== "admin" && (
//         <StoreDetails
//           title="Products"
//           value={analyticsData?.vendorData?.products || "0"}
//           // icon="↓"
//           bgColor="bg-[#D0C2E3]"
//           textColor="text-red-500"
//         />
//       )}
//     </div>
//   );
// };
// const BestSellingProductsTable = ({ vendors }) => {
//   return (
//     <div className="bg-white shadow-md rounded-lg overflow-hidden">
//       <h2 className="text-2xl font-bold text-gray-800 p-4 border-b">
//         Best Selling Products
//       </h2>
//       <table className="w-full text-left table-auto border-collapse">
//         <thead className="bg-gray-100 text-gray-600 uppercase text-sm leading-normal">
//           <tr>
//             <th className="p-3 border-b">ID</th>
//             <th className="p-3 border-b">Product</th>
//             <th className="p-3 border-b">Category</th>
//             <th className="p-3 border-b">Brand</th>
//             <th className="p-3 border-b">Price</th>
//             <th className="p-3 border-b">Stock</th>
//             <th className="p-3 border-b">Rating</th>
//             <th className="p-3 border-b">Orders</th>
//             <th className="p-3 border-b">Sales</th>
//           </tr>
//         </thead>
//         <tbody>
//           {vendors &&
//             vendors.map((product, index) => (
//               <tr
//                 key={index}
//                 className={`text-gray-700 hover:bg-gray-50 ${
//                   index % 2 === 0 ? "bg-white" : "bg-gray-50"
//                 }`}
//               >
//                 <td className="p-3 border-b">{product.id}</td>
//                 <td className="p-3 border-b font-medium">{product.product}</td>
//                 <td className="p-3 border-b">{product.category}</td>
//                 <td className="p-3 border-b">{product.brand}</td>
//                 <td className="p-3 border-b">{product.price}</td>
//                 <td className="p-3 border-b">{product.stock}</td>
//                 <td className="p-3 border-b">
//                   <span
//                     className={`inline-block px-2 py-1 text-sm rounded-full ${
//                       product.rating >= 4.5
//                         ? "bg-green-100 text-green-700"
//                         : "bg-yellow-100 text-yellow-700"
//                     }`}
//                   >
//                     {product.rating}
//                   </span>
//                 </td>
//                 <td className="p-3 border-b">{product.orders}</td>
//                 <td className="p-3 border-b">{product.sales}</td>
//               </tr>
//             ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// const PopularClientsTable = () => {
//   const clients = [
//     { id: "#4564", name: "Theresa Webb", orders: 300, amount: "$6500" },
//     // Add more clients as needed
//   ];

//   return (
//     <div>
//       <h2 className="text-xl font-semibold mb-4">Popular Client</h2>
//       <table className="w-full text-left border-collapse">
//         <thead>
//           <tr className="border-b">
//             <th className="p-2">ID</th>
//             <th className="p-2">CLIENT NAME</th>
//             <th className="p-2">ORDER</th>
//             <th className="p-2">AMOUNT</th>
//           </tr>
//         </thead>
//         <tbody>
//           {clients.map((client, index) => (
//             <tr key={index} className="border-b">
//               <td className="p-2">{client.id}</td>
//               <td className="p-2">{client.name}</td>
//               <td className="p-2">{client.orders}</td>
//               <td className="p-2">{client.amount}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };
// const StatsSection = (counts) => {
//   return (
//     <>
//       <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
//         <div className="flex items-center justify-between bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg rounded-lg p-6">
//           {/* Icon Section */}
//           <div className="flex items-center">
//             <div className="flex items-center justify-center w-16 h-16 rounded-full bg-white text-3xl text-blue-600 shadow-md">
//               🛍️
//             </div>
//             <div className="ml-4">
//               <h2 className="text-3xl font-bold">
//                 {counts?.counts?.total?.vendors || 0}
//               </h2>
//               <p className="text-gray-200">Total Vendors</p>
//             </div>
//           </div>
//           {/* Today's Count Section */}
//           <div className="text-right">
//             <p className="text-sm text-gray-100">Today's New Vendors</p>
//             <span
//               className={`text-lg font-semibold ${
//                 counts?.counts?.today?.vendors > 0
//                   ? "text-green-300"
//                   : "text-red-300"
//               }`}
//             >
//               {`+${counts?.counts?.today?.vendors || 0}`}
//             </span>
//           </div>
//         </div>
//         {/* Total Orders */}
//         <div className="flex items-center justify-between bg-gradient-to-r from-green-500 to-teal-600 text-white shadow-lg rounded-lg p-6">
//           <div className="flex items-center">
//             <div className="flex items-center justify-center w-16 h-16 rounded-full bg-white text-3xl text-green-600 shadow-md">
//               📦
//             </div>
//             <div className="ml-4">
//               <h2 className="text-3xl font-bold">
//                 {counts?.counts?.total?.orders || 0}
//               </h2>
//               <p className="text-gray-200">Total Orders</p>
//             </div>
//           </div>
//           <div className="text-right">
//             <p className="text-sm text-gray-100">Today's Orders</p>
//             <span
//               className={`text-lg font-semibold ${
//                 counts?.counts?.today?.orders > 0
//                   ? "text-green-300"
//                   : "text-red-300"
//               }`}
//             >
//               {`+${counts?.counts?.today?.orders}`}
//             </span>
//           </div>
//         </div>

//         {/* Tickets */}
//         <div className="flex items-center justify-between bg-gradient-to-r from-red-500 to-orange-600 text-white shadow-lg rounded-lg p-6">
//           <div className="flex items-center">
//             <div className="flex items-center justify-center w-16 h-16 rounded-full bg-white text-3xl text-red-600 shadow-md">
//               🎫
//             </div>
//             <div className="ml-4">
//               <h2 className="text-3xl font-bold">
//                 {counts?.counts?.total?.tickets || 0}
//               </h2>
//               <p className="text-gray-200">Total Tickets</p>
//             </div>
//           </div>
//           <div className="text-right">
//             <p className="text-sm text-gray-100">Today's Tickets</p>
//             <span
//               className={`text-lg font-semibold ${
//                 counts?.counts?.today?.tickets > 0
//                   ? "text-green-300"
//                   : "text-red-300"
//               }`}
//             >
//               {`+${counts?.counts?.today?.tickets}`}
//             </span>
//           </div>
//         </div>

//         {/* Demos */}
//         <div className="flex items-center justify-between bg-gradient-to-r from-purple-500 to-pink-600 text-white shadow-lg rounded-lg p-6">
//           <div className="flex items-center">
//             <div className="flex items-center justify-center w-16 h-16 rounded-full bg-white text-3xl text-purple-600 shadow-md">
//               🎥
//             </div>
//             <div className="ml-4">
//               <h2 className="text-3xl font-bold">
//                 {counts?.counts?.total?.demos || 0}
//               </h2>
//               <p className="text-gray-200">Total Demos</p>
//             </div>
//           </div>
//           <div className="text-right">
//             <p className="text-sm text-gray-100">Today's Demos</p>
//             <span
//               className={`text-lg font-semibold ${
//                 counts?.counts?.today?.demos > 0
//                   ? "text-green-300"
//                   : "text-red-300"
//               }`}
//             >
//               {`+${counts?.counts?.today?.demos}`}
//             </span>
//           </div>
//         </div>

//         {/* Scheduled Demos */}
//         <div className="flex items-center justify-between bg-gradient-to-r from-blue-500 to-indigo-600 text-white shadow-lg rounded-lg p-6">
//           <div className="flex items-center">
//             <div className="flex items-center justify-center w-16 h-16 rounded-full bg-white text-3xl text-blue-600 shadow-md">
//               📅
//             </div>
//             <div className="ml-4">
//               <h2 className="text-3xl font-bold">
//                 {counts?.counts?.total?.scheduledDemos || 0}
//               </h2>
//               <p className="text-gray-200">Scheduled Demos</p>
//             </div>
//           </div>
//           <div className="text-right">
//             <p className="text-sm text-gray-100">Today's Schedule</p>
//             <span
//               className={`text-lg font-semibold ${
//                 counts?.counts?.today?.scheduledDemos > 0
//                   ? "text-green-300"
//                   : "text-red-300"
//               }`}
//             >
//               {`+${counts?.counts?.today?.scheduledDemos || 0}`}
//             </span>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// import React, { useEffect, useState } from "react";
// import Layout, { Container } from "../components/layout.js";
// import { Link, useNavigate } from "react-router-dom";
// import { Doughnut, Line } from "react-chartjs-2";
// import { IoClose } from "react-icons/io5";
// import axios from "axios";
// import { getCookie } from "../config/webStorage.js";
// import { apiurl } from "../config/config.js";
// import { useUser } from "../config/userProvider.js";
// import { motion } from "framer-motion";
// import { GoDot } from "react-icons/go";

// // ==================== CHART.JS REGISTRATION ====================
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   ArcElement,
//   Tooltip,
//   Legend,
//   Filler,
// } from "chart.js";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   ArcElement,
//   Tooltip,
//   Legend,
//   Filler,
// );
// // ============================================================

// const Dashboard = () => {
//   const { userData } = useUser();
//   const userType = userData?.userType;

//   const [analyticsData, setAnalyticsData] = useState(null);
//   const [loadingData, setLoadingData] = useState(true);

//   useEffect(() => {
//     const Url =
//       userType === "superadmin"
//         ? `${apiurl}/admin/v1/analytic/report/dashboard/superadmin/all`
//         : userType === "admin"
//           ? `${apiurl}/admin/v1/analytic/report/dashboard/store`
//           : userType === "user"
//             ? `${apiurl}/admin/v1/analytic/report/dashboard/user`
//             : "";

//     if (!Url) return;

//     const payload = JSON.stringify({
//       vendorObjId: userData?.vendorDetails?.vendorObjId,
//       storeObjId: userData?.storeDetails?.storeObjId,
//       userObjId: userData?._id,
//     });

//     axios
//       .post(Url, payload, {
//         headers: { "Content-Type": "application/json" },
//       })
//       .then((response) => {
//         if (response.data.success) {
//           setAnalyticsData(response.data.data);
//         }
//       })
//       .catch((error) => console.log(error))
//       .finally(() => setLoadingData(false));
//   }, [userType, userData]);

//   return (
//     <Layout>
//       {userType === "master" ? (
//         <MasterDashboard />
//       ) : (
//         <CommonDashboard
//           analyticsData={analyticsData}
//           userData={userData}
//           userType={userType}
//         />
//       )}
//     </Layout>
//   );
// };

// export default Dashboard;

// // ==================== MASTER DASHBOARD ====================

// const MasterDashboard = () => {
//   const [reportData, setReportData] = useState({});
//   const token = getCookie("sctoken");

//   useEffect(() => {
//     axios
//       .get(`${apiurl}/admin/v1/dashboard/master/report`, {
//         headers: { Authorization: token },
//       })
//       .then((res) => {
//         if (res.data.success) setReportData(res.data.data);
//       })
//       .catch(console.log);
//   }, []);

//   return (
//     <Container overflow="overflow-scroll">
//       <div className="min-h-screen bg-gray-100 p-6">
//         <div className="bg-gray-100 pb-6">
//           <StatsSection counts={reportData?.counts} />
//         </div>
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//           <div className="col-span-2 bg-white rounded-lg shadow p-6">
//             <BestSellingProductsTable
//               vendors={reportData?.allRecords?.vendors}
//             />
//           </div>
//           <div className="bg-white rounded-lg shadow p-6">
//             <PopularClientsTable />
//           </div>
//         </div>
//       </div>
//     </Container>
//   );
// };

// // ==================== COMMON DASHBOARD ====================

// const CommonDashboard = ({ analyticsData, userData, userType }) => {
//   return (
//     <div className="relative overflow-y-scroll h-full p-6 bg-gray-50">
//       <Dashboard1
//         analyticsData={analyticsData}
//         userData={userData}
//         userType={userType}
//       />
//     </div>
//   );
// };

// // ==================== MAIN DASHBOARD CONTENT ====================

// const Dashboard1 = ({ analyticsData, userData, userType }) => {
//   const isSuperAdmin = userType === "superadmin";

//   // Superadmin Data
//   const allTimeData = analyticsData?.allTimeData || {};
//   const allTimeReport = analyticsData?.allTimeReport || {};

//   // Admin Data
//   const last30Days = analyticsData?.last30DaysReport || {};
//   const last4Weeks = analyticsData?.last4WeeksReport || {};
//   const last3Weeks = analyticsData?.last3WeeksReport || {};
//   const last2Weeks = analyticsData?.last2WeeksReport || {};
//   const last1Week = analyticsData?.last1WeekReport || {};

//   // ==================== DOUGHNUT CHART (Both Roles) ====================
//   let DoughnutData;

//   if (isSuperAdmin) {
//     const totalUsers = allTimeData.totalUsers || 0;
//     const activeUsers = allTimeData.activeUsers || 0;
//     const inactiveUsers = totalUsers - activeUsers;

//     DoughnutData = {
//       labels: ["Inactive Users", "Active Users"],
//       datasets: [
//         {
//           data: [inactiveUsers, activeUsers],
//           backgroundColor: ["#ff6384", "#36a2eb"],
//           hoverOffset: 10,
//         },
//       ],
//     };
//   } else {
//     // Admin Doughnut
//     DoughnutData = {
//       labels: ["Catalog Generated", "Catalog Downloaded", "WhatsApp Sent"],
//       datasets: [
//         {
//           data: [
//             last30Days.catalog_generated || 0,
//             last30Days.catalog_downloaded || 0,
//             last30Days.catalog_sent_whatsapp || 0,
//           ],
//           backgroundColor: ["#a855f7", "#3b82f6", "#ec4899"],
//           hoverOffset: 10,
//         },
//       ],
//     };
//   }

//   // ==================== LINE CHART - DIFFERENT FOR EACH ROLE ====================
//   let LineChartData;

//   if (isSuperAdmin) {
//     // Superadmin: Single clean line showing real different fields
//     // Using Catalog Downloaded (high volume) as main + WhatsApp Sent as secondary
//     LineChartData = {
//       labels: [
//         "Orders",
//         "Catalog Generated",
//         "Catalog Downloaded",
//         "WhatsApp Sent",
//         "Email Sent",
//       ],
//       datasets: [
//         {
//           label: "Last 30 Days",
//           data: [
//             allTimeReport.order_placed || 0,
//             allTimeReport.catalog_generated || 0,
//             allTimeReport.catalog_downloaded || 0,
//             allTimeReport.catalog_sent_whatsapp || 0,
//             allTimeReport.catalog_sent_email || 0,
//           ],
//           borderColor: "#3b82f6",
//           backgroundColor: "rgba(59, 130, 246, 0.1)",
//           tension: 0.4,
//           fill: true,
//           borderWidth: 3,
//         },
//       ],
//     };
//   } else {
//     // Admin: Weekly Trend (unchanged)
//     const lineLabels = [
//       "1 Week Ago",
//       "2 Weeks Ago",
//       "3 Weeks Ago",
//       "4 Weeks Ago",
//       "Last 30 Days",
//     ];
//     LineChartData = {
//       labels: lineLabels,
//       datasets: [
//         {
//           label: "Orders",
//           data: [
//             last1Week.order_placed || 0,
//             last2Weeks.order_placed || 0,
//             last3Weeks.order_placed || 0,
//             last4Weeks.order_placed || 0,
//             last30Days.order_placed || 0,
//           ],
//           borderColor: "#22c55e",
//           backgroundColor: "rgba(34, 197, 94, 0.1)",
//           tension: 0.4,
//           fill: true,
//         },
//         {
//           label: "Catalog Generated",
//           data: [
//             last1Week.catalog_generated || 0,
//             last2Weeks.catalog_generated || 0,
//             last3Weeks.catalog_generated || 0,
//             last4Weeks.catalog_generated || 0,
//             last30Days.catalog_generated || 0,
//           ],
//           borderColor: "#a855f7",
//           backgroundColor: "rgba(168, 85, 247, 0.1)",
//           tension: 0.4,
//           fill: true,
//         },
//         {
//           label: "Catalog Downloaded",
//           data: [
//             last1Week.catalog_downloaded || 0,
//             last2Weeks.catalog_downloaded || 0,
//             last3Weeks.catalog_downloaded || 0,
//             last4Weeks.catalog_downloaded || 0,
//             last30Days.catalog_downloaded || 0,
//           ],
//           borderColor: "#3b82f6",
//           backgroundColor: "rgba(59, 130, 246, 0.1)",
//           tension: 0.4,
//           fill: true,
//         },
//         {
//           label: "WhatsApp Sent",
//           data: [
//             last1Week.catalog_sent_whatsapp || 0,
//             last2Weeks.catalog_sent_whatsapp || 0,
//             last3Weeks.catalog_sent_whatsapp || 0,
//             last4Weeks.catalog_sent_whatsapp || 0,
//             last30Days.catalog_sent_whatsapp || 0,
//           ],
//           borderColor: "#ec4899",
//           backgroundColor: "rgba(236, 72, 153, 0.1)",
//           tension: 0.4,
//           fill: true,
//         },
//       ],
//     };
//   }

//   return (
//     <div className="max-w-7xl mx-auto">
//       {/* Logo Warning */}
//       {isSuperAdmin && userData?.vendorDetails?.logo?.upload === false && (
//         <motion.div
//           initial={{ opacity: 0, y: -10 }}
//           animate={{ opacity: 1, y: 0 }}
//           className="bg-red-50 border border-red-200 text-red-700 px-6 py-4 rounded-2xl mb-6 flex items-center justify-between"
//         >
//           <div className="flex items-center gap-3">
//             <IoClose className="text-2xl" />
//             <span className="font-medium">
//               Logo is mandatory. Please upload your vendor logo first.
//             </span>
//           </div>
//           <Link to="/settings/documents">
//             <button className="bg-red-600 text-white px-6 py-2.5 rounded-xl text-sm font-medium hover:bg-red-700 transition">
//               Upload Logo
//             </button>
//           </Link>
//         </motion.div>
//       )}

//       <div className="grid grid-cols-1 xl:grid-cols-12 gap-6">
//         {/* LEFT COLUMN */}
//         <div className="xl:col-span-5 space-y-6">
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="bg-white rounded-3xl shadow-sm p-8"
//           >
//             <h2 className="text-2xl font-semibold mb-8">
//               {isSuperAdmin ? "Overall Summary" : "Last 30 Days Performance"}
//             </h2>
//             <div className="space-y-5">
//               <StatCard
//                 label="Orders Placed"
//                 value={
//                   isSuperAdmin
//                     ? allTimeReport.order_placed
//                     : last30Days.order_placed
//                 }
//                 color="bg-emerald-100 text-emerald-700"
//               />
//               <StatCard
//                 label="Catalog Generated"
//                 value={
//                   isSuperAdmin
//                     ? allTimeReport.catalog_generated
//                     : last30Days.catalog_generated
//                 }
//                 color="bg-violet-100 text-violet-700"
//               />
//               <StatCard
//                 label="Catalog Downloaded"
//                 value={
//                   isSuperAdmin
//                     ? allTimeReport.catalog_downloaded
//                     : last30Days.catalog_downloaded
//                 }
//                 color="bg-blue-100 text-blue-700"
//               />
//               <StatCard
//                 label="WhatsApp Sent"
//                 value={
//                   isSuperAdmin
//                     ? allTimeReport.catalog_sent_whatsapp
//                     : last30Days.catalog_sent_whatsapp
//                 }
//                 color="bg-pink-100 text-pink-700"
//               />
//               <StatCard
//                 label="Email Sent"
//                 value={
//                   isSuperAdmin
//                     ? allTimeReport.catalog_sent_email
//                     : last30Days.catalog_sent_email
//                 }
//                 color="bg-amber-100 text-amber-700"
//               />
//             </div>
//           </motion.div>

//           {/* Doughnut Chart */}
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="bg-white rounded-3xl shadow-sm p-8"
//           >
//             <h3 className="text-xl font-semibold mb-6">
//               {isSuperAdmin
//                 ? "User Activity Distribution"
//                 : "Activity Distribution"}
//             </h3>
//             <div className="flex justify-center">
//               <div className="w-80 h-80">
//                 <Doughnut data={DoughnutData} />
//               </div>
//             </div>
//           </motion.div>
//         </div>

//         {/* RIGHT COLUMN */}
//         <div className="xl:col-span-7 space-y-6">
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="bg-white rounded-3xl shadow-sm p-8"
//           >
//             <h2 className="text-2xl font-semibold mb-8">
//               {isSuperAdmin ? "All Time Analytics" : "Store Analytics"}
//             </h2>
//             <AnalyticsDashboard
//               analyticsData={analyticsData}
//               userType={userType}
//             />
//           </motion.div>

//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="bg-white rounded-3xl shadow-sm p-8"
//           >
//             <h2 className="text-2xl font-semibold mb-8">
//               {isSuperAdmin ? "Last 30 Days Trend" : "Weekly Activity Trend"}
//             </h2>
//             <div className="h-[420px]">
//               <Line
//                 data={LineChartData}
//                 options={{
//                   responsive: true,
//                   maintainAspectRatio: false,
//                   plugins: {
//                     legend: { position: "top", align: "end" },
//                   },
//                   scales: {
//                     y: { beginAtZero: true, grid: { color: "#f1f5f9" } },
//                     x: { grid: { color: "#f1f5f9" } },
//                   },
//                 }}
//               />
//             </div>
//           </motion.div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // ==================== HELPER COMPONENTS ====================

// const StatCard = ({ label, value = 0, color }) => (
//   <div className="flex justify-between items-center bg-gray-50 px-6 py-5 rounded-2xl">
//     <p className="font-medium text-gray-700 flex items-center gap-3">
//       <GoDot className="text-gray-400" /> {label}
//     </p>
//     <p className={`font-bold text-3xl px-6 py-1 rounded-2xl ${color}`}>
//       {value.toLocaleString()}
//     </p>
//   </div>
// );

// const AnalyticsDashboard = ({ analyticsData, userType }) => {
//   const isSuperAdmin = userType === "superadmin";
//   const data = isSuperAdmin ? analyticsData?.allTimeData || {} : {};
//   const report = isSuperAdmin
//     ? analyticsData?.allTimeReport || {}
//     : analyticsData?.last30DaysReport || {};

//   return (
//     <div className="grid grid-cols-2 md:grid-cols-3 gap-5">
//       {isSuperAdmin && (
//         <>
//           <StoreDetails
//             title="Total Users"
//             value={data.totalUsers || 0}
//             bgColor="bg-[#E9CFFC]"
//           />
//           <StoreDetails
//             title="Active Users"
//             value={data.activeUsers || 0}
//             bgColor="bg-[#D0C2E3]"
//           />
//           <StoreDetails
//             title="Total Stores"
//             value={data.totalStores || 0}
//             bgColor="bg-[#C3EFD3]"
//           />
//           <StoreDetails
//             title="Total Products"
//             value={data.totalProducts || 0}
//             bgColor="bg-[#FFFDC7]"
//           />
//         </>
//       )}
//       <StoreDetails
//         title="Orders Placed"
//         value={report.order_placed || 0}
//         bgColor="bg-[#C6E3F3]"
//       />
//       <StoreDetails
//         title="Catalog Generated"
//         value={report.catalog_generated || 0}
//         bgColor="bg-[#E9CFFC]"
//       />
//       <StoreDetails
//         title="Catalog Downloaded"
//         value={report.catalog_downloaded || 0}
//         bgColor="bg-[#C6E3F3]"
//       />
//       <StoreDetails
//         title="WhatsApp Sent"
//         value={report.catalog_sent_whatsapp || 0}
//         bgColor="bg-[#C3EFD3]"
//       />
//       <StoreDetails
//         title="Email Sent"
//         value={report.catalog_sent_email || 0}
//         bgColor="bg-[#D0C2E3]"
//       />
//     </div>
//   );
// };

// const StoreDetails = ({ title, value, bgColor }) => (
//   <div className={`${bgColor} rounded-3xl p-6`}>
//     <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>
//     <p className="text-4xl font-bold text-gray-800">{value.toLocaleString()}</p>
//   </div>
// );

// // ==================== UNCHANGED COMPONENTS ====================

// const BestSellingProductsTable = ({ vendors }) => {
//   return (
//     <div className="bg-white shadow-md rounded-lg overflow-hidden">
//       <h2 className="text-2xl font-bold text-gray-800 p-4 border-b">
//         Best Selling Products
//       </h2>
//       <table className="w-full text-left table-auto border-collapse">
//         <thead className="bg-gray-100 text-gray-600 uppercase text-sm leading-normal">
//           <tr>
//             <th className="p-3 border-b">ID</th>
//             <th className="p-3 border-b">Product</th>
//             <th className="p-3 border-b">Category</th>
//             <th className="p-3 border-b">Brand</th>
//             <th className="p-3 border-b">Price</th>
//             <th className="p-3 border-b">Stock</th>
//             <th className="p-3 border-b">Rating</th>
//             <th className="p-3 border-b">Orders</th>
//             <th className="p-3 border-b">Sales</th>
//           </tr>
//         </thead>
//         <tbody>
//           {vendors?.map((product, index) => (
//             <tr
//               key={index}
//               className={`text-gray-700 hover:bg-gray-50 ${index % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
//             >
//               <td className="p-3 border-b">{product.id}</td>
//               <td className="p-3 border-b font-medium">{product.product}</td>
//               <td className="p-3 border-b">{product.category}</td>
//               <td className="p-3 border-b">{product.brand}</td>
//               <td className="p-3 border-b">{product.price}</td>
//               <td className="p-3 border-b">{product.stock}</td>
//               <td className="p-3 border-b">{product.rating}</td>
//               <td className="p-3 border-b">{product.orders}</td>
//               <td className="p-3 border-b">{product.sales}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// const PopularClientsTable = () => {
//   const clients = [
//     { id: "#4564", name: "Theresa Webb", orders: 300, amount: "$6500" },
//   ];
//   return (
//     <div>
//       <h2 className="text-xl font-semibold mb-4">Popular Clients</h2>
//       <table className="w-full text-left border-collapse">
//         <thead>
//           <tr className="border-b">
//             <th className="p-2">ID</th>
//             <th className="p-2">CLIENT NAME</th>
//             <th className="p-2">ORDER</th>
//             <th className="p-2">AMOUNT</th>
//           </tr>
//         </thead>
//         <tbody>
//           {clients.map((client, index) => (
//             <tr key={index} className="border-b">
//               <td className="p-2">{client.id}</td>
//               <td className="p-2">{client.name}</td>
//               <td className="p-2">{client.orders}</td>
//               <td className="p-2">{client.amount}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// const StatsSection = (counts) => {
//   return (
//     <>
//       <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
//         <div className="flex items-center justify-between bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg rounded-lg p-6">
//           {/* Icon Section */}
//           <div className="flex items-center">
//             <div className="flex items-center justify-center w-16 h-16 rounded-full bg-white text-3xl text-blue-600 shadow-md">
//               🛍️
//             </div>
//             <div className="ml-4">
//               <h2 className="text-3xl font-bold">
//                 {counts?.counts?.total?.vendors || 0}
//               </h2>
//               <p className="text-gray-200">Total Vendors</p>
//             </div>
//           </div>
//           {/* Today's Count Section */}
//           <div className="text-right">
//             <p className="text-sm text-gray-100">Today's New Vendors</p>
//             <span
//               className={`text-lg font-semibold ${
//                 counts?.counts?.today?.vendors > 0
//                   ? "text-green-300"
//                   : "text-red-300"
//               }`}
//             >
//               {`+${counts?.counts?.today?.vendors || 0}`}
//             </span>
//           </div>
//         </div>
//         {/* Total Orders */}
//         <div className="flex items-center justify-between bg-gradient-to-r from-green-500 to-teal-600 text-white shadow-lg rounded-lg p-6">
//           <div className="flex items-center">
//             <div className="flex items-center justify-center w-16 h-16 rounded-full bg-white text-3xl text-green-600 shadow-md">
//               📦
//             </div>
//             <div className="ml-4">
//               <h2 className="text-3xl font-bold">
//                 {counts?.counts?.total?.orders || 0}
//               </h2>
//               <p className="text-gray-200">Total Orders</p>
//             </div>
//           </div>
//           <div className="text-right">
//             <p className="text-sm text-gray-100">Today's Orders</p>
//             <span
//               className={`text-lg font-semibold ${
//                 counts?.counts?.today?.orders > 0
//                   ? "text-green-300"
//                   : "text-red-300"
//               }`}
//             >
//               {`+${counts?.counts?.today?.orders}`}
//             </span>
//           </div>
//         </div>

//         {/* Tickets */}
//         <div className="flex items-center justify-between bg-gradient-to-r from-red-500 to-orange-600 text-white shadow-lg rounded-lg p-6">
//           <div className="flex items-center">
//             <div className="flex items-center justify-center w-16 h-16 rounded-full bg-white text-3xl text-red-600 shadow-md">
//               🎫
//             </div>
//             <div className="ml-4">
//               <h2 className="text-3xl font-bold">
//                 {counts?.counts?.total?.tickets || 0}
//               </h2>
//               <p className="text-gray-200">Total Tickets</p>
//             </div>
//           </div>
//           <div className="text-right">
//             <p className="text-sm text-gray-100">Today's Tickets</p>
//             <span
//               className={`text-lg font-semibold ${
//                 counts?.counts?.today?.tickets > 0
//                   ? "text-green-300"
//                   : "text-red-300"
//               }`}
//             >
//               {`+${counts?.counts?.today?.tickets}`}
//             </span>
//           </div>
//         </div>

//         {/* Demos */}
//         <div className="flex items-center justify-between bg-gradient-to-r from-purple-500 to-pink-600 text-white shadow-lg rounded-lg p-6">
//           <div className="flex items-center">
//             <div className="flex items-center justify-center w-16 h-16 rounded-full bg-white text-3xl text-purple-600 shadow-md">
//               🎥
//             </div>
//             <div className="ml-4">
//               <h2 className="text-3xl font-bold">
//                 {counts?.counts?.total?.demos || 0}
//               </h2>
//               <p className="text-gray-200">Total Demos</p>
//             </div>
//           </div>
//           <div className="text-right">
//             <p className="text-sm text-gray-100">Today's Demos</p>
//             <span
//               className={`text-lg font-semibold ${
//                 counts?.counts?.today?.demos > 0
//                   ? "text-green-300"
//                   : "text-red-300"
//               }`}
//             >
//               {`+${counts?.counts?.today?.demos}`}
//             </span>
//           </div>
//         </div>

//         {/* Scheduled Demos */}
//         <div className="flex items-center justify-between bg-gradient-to-r from-blue-500 to-indigo-600 text-white shadow-lg rounded-lg p-6">
//           <div className="flex items-center">
//             <div className="flex items-center justify-center w-16 h-16 rounded-full bg-white text-3xl text-blue-600 shadow-md">
//               📅
//             </div>
//             <div className="ml-4">
//               <h2 className="text-3xl font-bold">
//                 {counts?.counts?.total?.scheduledDemos || 0}
//               </h2>
//               <p className="text-gray-200">Scheduled Demos</p>
//             </div>
//           </div>
//           <div className="text-right">
//             <p className="text-sm text-gray-100">Today's Schedule</p>
//             <span
//               className={`text-lg font-semibold ${
//                 counts?.counts?.today?.scheduledDemos > 0
//                   ? "text-green-300"
//                   : "text-red-300"
//               }`}
//             >
//               {`+${counts?.counts?.today?.scheduledDemos || 0}`}
//             </span>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// import React, { useEffect, useState } from "react";
// import Layout, { Container } from "../components/layout.js";
// import { Link } from "react-router-dom";
// import { Doughnut, Line } from "react-chartjs-2";
// import { IoClose } from "react-icons/io5";
// import axios from "axios";
// import { getCookie } from "../config/webStorage.js";
// import { apiurl } from "../config/config.js";
// import { useUser } from "../config/userProvider.js";
// import { motion } from "framer-motion";
// import { GoDot } from "react-icons/go";

// // ==================== CHART.JS REGISTRATION ====================
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   ArcElement,
//   Tooltip,
//   Legend,
//   Filler,
// } from "chart.js";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   ArcElement,
//   Tooltip,
//   Legend,
//   Filler,
// );
// // ============================================================

// // ==================== SKELETON COMPONENTS ====================

// const Skeleton = ({ className = "" }) => (
//   <div
//     className={`animate-pulse bg-gray-200 rounded-lg ${className}`}
//     style={{
//       background:
//         "linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%)",
//       backgroundSize: "200% 100%",
//       animation: "shimmer 1.5s infinite",
//     }}
//   />
// );

// // Inject shimmer keyframe once
// if (
//   typeof document !== "undefined" &&
//   !document.getElementById("skeleton-style")
// ) {
//   const style = document.createElement("style");
//   style.id = "skeleton-style";
//   style.textContent = `
//     @keyframes shimmer {
//       0% { background-position: 200% 0; }
//       100% { background-position: -200% 0; }
//     }
//   `;
//   document.head.appendChild(style);
// }

// const StatCardSkeleton = () => (
//   <div className="flex justify-between items-center bg-gray-50 px-6 py-5 rounded-2xl">
//     <div className="flex items-center gap-3">
//       <Skeleton className="w-4 h-4 rounded-full" />
//       <Skeleton className="h-4 w-32" />
//     </div>
//     <Skeleton className="h-10 w-20 rounded-2xl" />
//   </div>
// );

// const StoreDetailSkeleton = ({ bgColor = "bg-gray-100" }) => (
//   <div className={`${bgColor} rounded-3xl p-6`}>
//     <Skeleton className="h-3 w-24 mb-3" />
//     <Skeleton className="h-10 w-16" />
//   </div>
// );

// const DoughnutSkeleton = () => (
//   <div className="flex justify-center items-center w-80 h-80 mx-auto">
//     <div className="relative w-64 h-64">
//       <div
//         className="w-full h-full rounded-full"
//         style={{
//           background:
//             "conic-gradient(#e5e7eb 0deg, #f3f4f6 120deg, #e5e7eb 240deg, #f3f4f6 360deg)",
//           animation: "shimmer 1.5s infinite",
//           backgroundSize: "200% 100%",
//         }}
//       />
//       <div className="absolute inset-0 flex items-center justify-center">
//         <div className="w-28 h-28 rounded-full bg-white" />
//       </div>
//     </div>
//   </div>
// );

// const LineChartSkeleton = () => (
//   <div className="h-[420px] flex flex-col justify-end gap-2 px-4 pb-6 pt-10">
//     <div className="flex items-end gap-3 h-full">
//       {[60, 85, 45, 70, 90, 55, 75, 40, 80, 65].map((h, i) => (
//         <div key={i} className="flex-1 flex flex-col justify-end gap-1">
//           <Skeleton
//             className="w-full"
//             style={{ height: `${h}%`, borderRadius: "4px 4px 0 0" }}
//           />
//         </div>
//       ))}
//     </div>
//     <div className="flex gap-3">
//       {[60, 85, 45, 70, 90, 55, 75, 40, 80, 65].map((_, i) => (
//         <Skeleton key={i} className="flex-1 h-3" />
//       ))}
//     </div>
//   </div>
// );

// const TableSkeleton = ({ rows = 5, cols = 9 }) => (
//   <div className="bg-white shadow-md rounded-lg overflow-hidden">
//     <div className="p-4 border-b">
//       <Skeleton className="h-7 w-48" />
//     </div>
//     <table className="w-full">
//       <thead className="bg-gray-100">
//         <tr>
//           {Array.from({ length: cols }).map((_, i) => (
//             <th key={i} className="p-3">
//               <Skeleton className="h-3 w-full" />
//             </th>
//           ))}
//         </tr>
//       </thead>
//       <tbody>
//         {Array.from({ length: rows }).map((_, row) => (
//           <tr key={row} className={row % 2 === 0 ? "bg-white" : "bg-gray-50"}>
//             {Array.from({ length: cols }).map((_, col) => (
//               <td key={col} className="p-3">
//                 <Skeleton className="h-4 w-full" />
//               </td>
//             ))}
//           </tr>
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const StatsSkeleton = () => (
//   <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
//     {[
//       "from-blue-500 to-purple-600",
//       "from-green-500 to-teal-600",
//       "from-red-500 to-orange-600",
//       "from-purple-500 to-pink-600",
//       "from-blue-500 to-indigo-600",
//     ].map((gradient, i) => (
//       <div
//         key={i}
//         className={`flex items-center justify-between bg-gradient-to-r ${gradient} text-white shadow-lg rounded-lg p-6`}
//       >
//         <div className="flex items-center">
//           <div className="w-16 h-16 rounded-full bg-white/30 animate-pulse" />
//           <div className="ml-4 space-y-2">
//             <div className="h-8 w-16 bg-white/30 rounded animate-pulse" />
//             <div className="h-4 w-24 bg-white/20 rounded animate-pulse" />
//           </div>
//         </div>
//         <div className="text-right space-y-2">
//           <div className="h-3 w-24 bg-white/20 rounded animate-pulse" />
//           <div className="h-6 w-10 bg-white/30 rounded animate-pulse ml-auto" />
//         </div>
//       </div>
//     ))}
//   </div>
// );

// // ============================================================

// const Dashboard = () => {
//   const { userData } = useUser();
//   const userType = userData?.userType;

//   const [analyticsData, setAnalyticsData] = useState(null);
//   const [loadingData, setLoadingData] = useState(true);

//   useEffect(() => {
//     const Url =
//       userType === "superadmin"
//         ? `${apiurl}/admin/v1/analytic/report/dashboard/superadmin/all`
//         : userType === "admin"
//           ? `${apiurl}/admin/v1/analytic/report/dashboard/store`
//           : userType === "user"
//             ? `${apiurl}/admin/v1/analytic/report/dashboard/user`
//             : "";

//     if (!Url) return;

//     const payload = JSON.stringify({
//       vendorObjId: userData?.vendorDetails?.vendorObjId,
//       storeObjId: userData?.storeDetails?.storeObjId,
//       userObjId: userData?._id,
//     });

//     axios
//       .post(Url, payload, {
//         headers: { "Content-Type": "application/json" },
//       })
//       .then((response) => {
//         if (response.data.success) {
//           setAnalyticsData(response.data.data);
//         }
//       })
//       .catch((error) => console.log(error))
//       .finally(() => setLoadingData(false));
//   }, [userType, userData]);

//   return (
//     <Layout>
//       {userType === "master" ? (
//         <MasterDashboard />
//       ) : (
//         <CommonDashboard
//           analyticsData={analyticsData}
//           userData={userData}
//           userType={userType}
//           loadingData={loadingData}
//         />
//       )}
//     </Layout>
//   );
// };

// export default Dashboard;

// // ==================== MASTER DASHBOARD ====================

// const MasterDashboard = () => {
//   const [reportData, setReportData] = useState({});
//   const [loading, setLoading] = useState(true);
//   const token = getCookie("sctoken");

//   // useEffect(() => {
//   //   axios
//   //     .get(`${apiurl}/admin/v1/dashboard/master/report`, {
//   //       headers: { Authorization: token },
//   //     })
//   //     .then((res) => {
//   //       if (res.data.success) setReportData(res.data.data);
//   //     })
//   //     .catch(console.log)
//   //     .finally(() => setLoading(false));
//   // }, []);

//   useEffect(() => {
//     const fetchReport = async () => {
//       try {
//         const res = await axios.get(
//           `${apiurl}/admin/v1/dashboard/master/report`,
//           {
//             headers: { Authorization: token },
//           },
//         );

//         if (res.data.success) {
//           setReportData(res.data.data);
//         }
//       } catch (err) {
//         console.log(err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (token) fetchReport();
//   }, [token]);

//   return (
//     <Container overflow="overflow-scroll">
//       <div className="min-h-screen bg-gray-100 p-6">
//         <div className="bg-gray-100 pb-6">
//           {loading ? (
//             <StatsSkeleton />
//           ) : (
//             <StatsSection counts={reportData?.counts} />
//           )}
//         </div>
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//           <div className="col-span-2 bg-white rounded-lg shadow p-6">
//             {loading ? (
//               <TableSkeleton rows={5} cols={9} />
//             ) : (
//               <BestSellingProductsTable
//                 vendors={reportData?.allRecords?.vendors}
//               />
//             )}
//           </div>
//           <div className="bg-white rounded-lg shadow p-6">
//             {loading ? (
//               <div>
//                 <Skeleton className="h-6 w-36 mb-4" />
//                 <TableSkeleton rows={3} cols={4} />
//               </div>
//             ) : (
//               <PopularClientsTable />
//             )}
//           </div>
//         </div>
//       </div>
//     </Container>
//   );
// };

// // ==================== COMMON DASHBOARD ====================

// const CommonDashboard = ({
//   analyticsData,
//   userData,
//   userType,
//   loadingData,
// }) => {
//   return (
//     <div className="relative overflow-y-scroll h-full p-6 bg-gray-50">
//       <Dashboard1
//         analyticsData={analyticsData}
//         userData={userData}
//         userType={userType}
//         loadingData={loadingData}
//       />
//     </div>
//   );
// };

// // ==================== MAIN DASHBOARD CONTENT ====================

// const Dashboard1 = ({ analyticsData, userData, userType, loadingData }) => {
//   const isSuperAdmin = userType === "superadmin";

//   // Superadmin Data
//   const allTimeData = analyticsData?.allTimeData || {};
//   const allTimeReport = analyticsData?.allTimeReport || {};

//   // Admin Data
//   const last30Days = analyticsData?.last30DaysReport || {};
//   const last4Weeks = analyticsData?.last4WeeksReport || {};
//   const last3Weeks = analyticsData?.last3WeeksReport || {};
//   const last2Weeks = analyticsData?.last2WeeksReport || {};
//   const last1Week = analyticsData?.last1WeekReport || {};

//   // ==================== DOUGHNUT CHART (Both Roles) ====================
//   let DoughnutData;

//   if (isSuperAdmin) {
//     const totalUsers = allTimeData.totalUsers || 0;
//     const activeUsers = allTimeData.activeUsers || 0;
//     const inactiveUsers = totalUsers - activeUsers;

//     DoughnutData = {
//       labels: ["Inactive Users", "Active Users"],
//       datasets: [
//         {
//           data: [inactiveUsers, activeUsers],
//           backgroundColor: ["#ff6384", "#36a2eb"],
//           hoverOffset: 10,
//         },
//       ],
//     };
//   } else {
//     DoughnutData = {
//       labels: ["Catalog Generated", "Catalog Downloaded", "WhatsApp Sent"],
//       datasets: [
//         {
//           data: [
//             last30Days.catalog_generated || 0,
//             last30Days.catalog_downloaded || 0,
//             last30Days.catalog_sent_whatsapp || 0,
//           ],
//           backgroundColor: ["#a855f7", "#3b82f6", "#ec4899"],
//           hoverOffset: 10,
//         },
//       ],
//     };
//   }

//   // ==================== LINE CHART ====================
//   let LineChartData;

//   if (isSuperAdmin) {
//     LineChartData = {
//       labels: [
//         "Orders",
//         "Catalog Generated",
//         "Catalog Downloaded",
//         "WhatsApp Sent",
//         "Email Sent",
//       ],
//       datasets: [
//         {
//           label: "Last 30 Days",
//           data: [
//             allTimeReport.order_placed || 0,
//             allTimeReport.catalog_generated || 0,
//             allTimeReport.catalog_downloaded || 0,
//             allTimeReport.catalog_sent_whatsapp || 0,
//             allTimeReport.catalog_sent_email || 0,
//           ],
//           borderColor: "#3b82f6",
//           backgroundColor: "rgba(59, 130, 246, 0.1)",
//           tension: 0.4,
//           fill: true,
//           borderWidth: 3,
//         },
//       ],
//     };
//   } else {
//     const lineLabels = [
//       "1 Week Ago",
//       "2 Weeks Ago",
//       "3 Weeks Ago",
//       "4 Weeks Ago",
//       "Last 30 Days",
//     ];
//     LineChartData = {
//       labels: lineLabels,
//       datasets: [
//         {
//           label: "Orders",
//           data: [
//             last1Week.order_placed || 0,
//             last2Weeks.order_placed || 0,
//             last3Weeks.order_placed || 0,
//             last4Weeks.order_placed || 0,
//             last30Days.order_placed || 0,
//           ],
//           borderColor: "#22c55e",
//           backgroundColor: "rgba(34, 197, 94, 0.1)",
//           tension: 0.4,
//           fill: true,
//         },
//         {
//           label: "Catalog Generated",
//           data: [
//             last1Week.catalog_generated || 0,
//             last2Weeks.catalog_generated || 0,
//             last3Weeks.catalog_generated || 0,
//             last4Weeks.catalog_generated || 0,
//             last30Days.catalog_generated || 0,
//           ],
//           borderColor: "#a855f7",
//           backgroundColor: "rgba(168, 85, 247, 0.1)",
//           tension: 0.4,
//           fill: true,
//         },
//         {
//           label: "Catalog Downloaded",
//           data: [
//             last1Week.catalog_downloaded || 0,
//             last2Weeks.catalog_downloaded || 0,
//             last3Weeks.catalog_downloaded || 0,
//             last4Weeks.catalog_downloaded || 0,
//             last30Days.catalog_downloaded || 0,
//           ],
//           borderColor: "#3b82f6",
//           backgroundColor: "rgba(59, 130, 246, 0.1)",
//           tension: 0.4,
//           fill: true,
//         },
//         {
//           label: "WhatsApp Sent",
//           data: [
//             last1Week.catalog_sent_whatsapp || 0,
//             last2Weeks.catalog_sent_whatsapp || 0,
//             last3Weeks.catalog_sent_whatsapp || 0,
//             last4Weeks.catalog_sent_whatsapp || 0,
//             last30Days.catalog_sent_whatsapp || 0,
//           ],
//           borderColor: "#ec4899",
//           backgroundColor: "rgba(236, 72, 153, 0.1)",
//           tension: 0.4,
//           fill: true,
//         },
//       ],
//     };
//   }

//   return (
//     <div className="max-w-7xl mx-auto">
//       {/* Logo Warning */}
//       {!loadingData &&
//         isSuperAdmin &&
//         userData?.vendorDetails?.logo?.upload === false && (
//           <motion.div
//             initial={{ opacity: 0, y: -10 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="bg-red-50 border border-red-200 text-red-700 px-6 py-4 rounded-2xl mb-6 flex items-center justify-between"
//           >
//             <div className="flex items-center gap-3">
//               <IoClose className="text-2xl" />
//               <span className="font-medium">
//                 Logo is mandatory. Please upload your vendor logo first.
//               </span>
//             </div>
//             <Link to="/settings/documents">
//               <button className="bg-red-600 text-white px-6 py-2.5 rounded-xl text-sm font-medium hover:bg-red-700 transition">
//                 Upload Logo
//               </button>
//             </Link>
//           </motion.div>
//         )}

//       <div className="grid grid-cols-1 xl:grid-cols-12 gap-6">
//         {/* LEFT COLUMN */}
//         <div className="xl:col-span-5 space-y-6">
//           {/* Summary Stats Card */}
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="bg-white rounded-3xl shadow-sm p-8"
//           >
//             {loadingData ? (
//               <>
//                 <Skeleton className="h-7 w-56 mb-8" />
//                 <div className="space-y-5">
//                   {Array.from({ length: 5 }).map((_, i) => (
//                     <StatCardSkeleton key={i} />
//                   ))}
//                 </div>
//               </>
//             ) : (
//               <>
//                 <h2 className="text-2xl font-semibold mb-8">
//                   {isSuperAdmin
//                     ? "Overall Summary"
//                     : "Last 30 Days Performance"}
//                 </h2>
//                 <div className="space-y-5">
//                   <StatCard
//                     label="Orders Placed"
//                     value={
//                       isSuperAdmin
//                         ? allTimeReport.order_placed
//                         : last30Days.order_placed
//                     }
//                     color="bg-emerald-100 text-emerald-700"
//                   />
//                   <StatCard
//                     label="Catalog Generated"
//                     value={
//                       isSuperAdmin
//                         ? allTimeReport.catalog_generated
//                         : last30Days.catalog_generated
//                     }
//                     color="bg-violet-100 text-violet-700"
//                   />
//                   <StatCard
//                     label="Catalog Downloaded"
//                     value={
//                       isSuperAdmin
//                         ? allTimeReport.catalog_downloaded
//                         : last30Days.catalog_downloaded
//                     }
//                     color="bg-blue-100 text-blue-700"
//                   />
//                   <StatCard
//                     label="WhatsApp Sent"
//                     value={
//                       isSuperAdmin
//                         ? allTimeReport.catalog_sent_whatsapp
//                         : last30Days.catalog_sent_whatsapp
//                     }
//                     color="bg-pink-100 text-pink-700"
//                   />
//                   <StatCard
//                     label="Email Sent"
//                     value={
//                       isSuperAdmin
//                         ? allTimeReport.catalog_sent_email
//                         : last30Days.catalog_sent_email
//                     }
//                     color="bg-amber-100 text-amber-700"
//                   />
//                 </div>
//               </>
//             )}
//           </motion.div>

//           {/* Doughnut Chart */}
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="bg-white rounded-3xl shadow-sm p-8"
//           >
//             {loadingData ? (
//               <>
//                 <Skeleton className="h-6 w-44 mb-6" />
//                 <DoughnutSkeleton />
//               </>
//             ) : (
//               <>
//                 <h3 className="text-xl font-semibold mb-6">
//                   {isSuperAdmin
//                     ? "User Activity Distribution"
//                     : "Activity Distribution"}
//                 </h3>
//                 <div className="flex justify-center">
//                   <div className="w-80 h-80">
//                     <Doughnut data={DoughnutData} />
//                   </div>
//                 </div>
//               </>
//             )}
//           </motion.div>
//         </div>

//         {/* RIGHT COLUMN */}
//         <div className="xl:col-span-7 space-y-6">
//           {/* Analytics Grid */}
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="bg-white rounded-3xl shadow-sm p-8"
//           >
//             {loadingData ? (
//               <>
//                 <Skeleton className="h-7 w-48 mb-8" />
//                 <div className="grid grid-cols-2 md:grid-cols-3 gap-5">
//                   {[
//                     "bg-[#E9CFFC]",
//                     "bg-[#D0C2E3]",
//                     "bg-[#C3EFD3]",
//                     "bg-[#FFFDC7]",
//                     "bg-[#C6E3F3]",
//                     "bg-[#E9CFFC]",
//                   ].map((bg, i) => (
//                     <StoreDetailSkeleton key={i} bgColor={bg} />
//                   ))}
//                 </div>
//               </>
//             ) : (
//               <>
//                 <h2 className="text-2xl font-semibold mb-8">
//                   {isSuperAdmin ? "All Time Analytics" : "Store Analytics"}
//                 </h2>
//                 <AnalyticsDashboard
//                   analyticsData={analyticsData}
//                   userType={userType}
//                 />
//               </>
//             )}
//           </motion.div>

//           {/* Line Chart */}
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="bg-white rounded-3xl shadow-sm p-8"
//           >
//             {loadingData ? (
//               <>
//                 <Skeleton className="h-7 w-52 mb-8" />
//                 <LineChartSkeleton />
//               </>
//             ) : (
//               <>
//                 <h2 className="text-2xl font-semibold mb-8">
//                   {isSuperAdmin
//                     ? "Last 30 Days Trend"
//                     : "Weekly Activity Trend"}
//                 </h2>
//                 <div className="h-[420px]">
//                   <Line
//                     data={LineChartData}
//                     options={{
//                       responsive: true,
//                       maintainAspectRatio: false,
//                       plugins: {
//                         legend: { position: "top", align: "end" },
//                       },
//                       scales: {
//                         y: { beginAtZero: true, grid: { color: "#f1f5f9" } },
//                         x: { grid: { color: "#f1f5f9" } },
//                       },
//                     }}
//                   />
//                 </div>
//               </>
//             )}
//           </motion.div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // ==================== HELPER COMPONENTS ====================

// const StatCard = ({ label, value = 0, color }) => (
//   <div className="flex justify-between items-center bg-gray-50 px-6 py-5 rounded-2xl">
//     <p className="font-medium text-gray-700 flex items-center gap-3">
//       <GoDot className="text-gray-400" /> {label}
//     </p>
//     <p className={`font-bold text-3xl px-6 py-1 rounded-2xl ${color}`}>
//       {value.toLocaleString()}
//     </p>
//   </div>
// );

// const AnalyticsDashboard = ({ analyticsData, userType }) => {
//   const isSuperAdmin = userType === "superadmin";
//   const data = isSuperAdmin ? analyticsData?.allTimeData || {} : {};
//   const report = isSuperAdmin
//     ? analyticsData?.allTimeReport || {}
//     : analyticsData?.last30DaysReport || {};

//   return (
//     <div className="grid grid-cols-2 md:grid-cols-3 gap-5">
//       {isSuperAdmin && (
//         <>
//           <StoreDetails
//             title="Total Users"
//             value={data.totalUsers || 0}
//             bgColor="bg-[#E9CFFC]"
//           />
//           <StoreDetails
//             title="Active Users"
//             value={data.activeUsers || 0}
//             bgColor="bg-[#D0C2E3]"
//           />
//           <StoreDetails
//             title="Total Stores"
//             value={data.totalStores || 0}
//             bgColor="bg-[#C3EFD3]"
//           />
//           <StoreDetails
//             title="Total Products"
//             value={data.totalProducts || 0}
//             bgColor="bg-[#FFFDC7]"
//           />
//         </>
//       )}
//       <StoreDetails
//         title="Orders Placed"
//         value={report.order_placed || 0}
//         bgColor="bg-[#C6E3F3]"
//       />
//       <StoreDetails
//         title="Catalog Generated"
//         value={report.catalog_generated || 0}
//         bgColor="bg-[#E9CFFC]"
//       />
//       <StoreDetails
//         title="Catalog Downloaded"
//         value={report.catalog_downloaded || 0}
//         bgColor="bg-[#C6E3F3]"
//       />
//       <StoreDetails
//         title="WhatsApp Sent"
//         value={report.catalog_sent_whatsapp || 0}
//         bgColor="bg-[#C3EFD3]"
//       />
//       <StoreDetails
//         title="Email Sent"
//         value={report.catalog_sent_email || 0}
//         bgColor="bg-[#D0C2E3]"
//       />
//     </div>
//   );
// };

// const StoreDetails = ({ title, value, bgColor }) => (
//   <div className={`${bgColor} rounded-3xl p-6`}>
//     <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>
//     <p className="text-4xl font-bold text-gray-800">{value.toLocaleString()}</p>
//   </div>
// );

// // ==================== UNCHANGED COMPONENTS ====================

// const BestSellingProductsTable = ({ vendors }) => {
//   return (
//     <div className="bg-white shadow-md rounded-lg overflow-hidden">
//       <h2 className="text-2xl font-bold text-gray-800 p-4 border-b">
//         Best Selling Products
//       </h2>
//       <table className="w-full text-left table-auto border-collapse">
//         <thead className="bg-gray-100 text-gray-600 uppercase text-sm leading-normal">
//           <tr>
//             <th className="p-3 border-b">ID</th>
//             <th className="p-3 border-b">Product</th>
//             <th className="p-3 border-b">Category</th>
//             <th className="p-3 border-b">Brand</th>
//             <th className="p-3 border-b">Price</th>
//             <th className="p-3 border-b">Stock</th>
//             <th className="p-3 border-b">Rating</th>
//             <th className="p-3 border-b">Orders</th>
//             <th className="p-3 border-b">Sales</th>
//           </tr>
//         </thead>
//         <tbody>
//           {vendors?.map((product, index) => (
//             <tr
//               key={index}
//               className={`text-gray-700 hover:bg-gray-50 ${index % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
//             >
//               <td className="p-3 border-b">{product.id}</td>
//               <td className="p-3 border-b font-medium">{product.product}</td>
//               <td className="p-3 border-b">{product.category}</td>
//               <td className="p-3 border-b">{product.brand}</td>
//               <td className="p-3 border-b">{product.price}</td>
//               <td className="p-3 border-b">{product.stock}</td>
//               <td className="p-3 border-b">{product.rating}</td>
//               <td className="p-3 border-b">{product.orders}</td>
//               <td className="p-3 border-b">{product.sales}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// const PopularClientsTable = () => {
//   const clients = [
//     { id: "#4564", name: "Theresa Webb", orders: 300, amount: "$6500" },
//   ];
//   return (
//     <div>
//       <h2 className="text-xl font-semibold mb-4">Popular Clients</h2>
//       <table className="w-full text-left border-collapse">
//         <thead>
//           <tr className="border-b">
//             <th className="p-2">ID</th>
//             <th className="p-2">CLIENT NAME</th>
//             <th className="p-2">ORDER</th>
//             <th className="p-2">AMOUNT</th>
//           </tr>
//         </thead>
//         <tbody>
//           {clients.map((client, index) => (
//             <tr key={index} className="border-b">
//               <td className="p-2">{client.id}</td>
//               <td className="p-2">{client.name}</td>
//               <td className="p-2">{client.orders}</td>
//               <td className="p-2">{client.amount}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// const StatsSection = (counts) => {
//   return (
//     <>
//       <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
//         <div className="flex items-center justify-between bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg rounded-lg p-6">
//           <div className="flex items-center">
//             <div className="flex items-center justify-center w-16 h-16 rounded-full bg-white text-3xl text-blue-600 shadow-md">
//               🛍️
//             </div>
//             <div className="ml-4">
//               <h2 className="text-3xl font-bold">
//                 {counts?.counts?.total?.vendors || 0}
//               </h2>
//               <p className="text-gray-200">Total Vendors</p>
//             </div>
//           </div>
//           <div className="text-right">
//             <p className="text-sm text-gray-100">Today's New Vendors</p>
//             <span
//               className={`text-lg font-semibold ${
//                 counts?.counts?.today?.vendors > 0
//                   ? "text-green-300"
//                   : "text-red-300"
//               }`}
//             >
//               {`+${counts?.counts?.today?.vendors || 0}`}
//             </span>
//           </div>
//         </div>

//         <div className="flex items-center justify-between bg-gradient-to-r from-green-500 to-teal-600 text-white shadow-lg rounded-lg p-6">
//           <div className="flex items-center">
//             <div className="flex items-center justify-center w-16 h-16 rounded-full bg-white text-3xl text-green-600 shadow-md">
//               📦
//             </div>
//             <div className="ml-4">
//               <h2 className="text-3xl font-bold">
//                 {counts?.counts?.total?.orders || 0}
//               </h2>
//               <p className="text-gray-200">Total Orders</p>
//             </div>
//           </div>
//           <div className="text-right">
//             <p className="text-sm text-gray-100">Today's Orders</p>
//             <span
//               className={`text-lg font-semibold ${
//                 counts?.counts?.today?.orders > 0
//                   ? "text-green-300"
//                   : "text-red-300"
//               }`}
//             >
//               {`+${counts?.counts?.today?.orders}`}
//             </span>
//           </div>
//         </div>

//         <div className="flex items-center justify-between bg-gradient-to-r from-red-500 to-orange-600 text-white shadow-lg rounded-lg p-6">
//           <div className="flex items-center">
//             <div className="flex items-center justify-center w-16 h-16 rounded-full bg-white text-3xl text-red-600 shadow-md">
//               🎫
//             </div>
//             <div className="ml-4">
//               <h2 className="text-3xl font-bold">
//                 {counts?.counts?.total?.tickets || 0}
//               </h2>
//               <p className="text-gray-200">Total Tickets</p>
//             </div>
//           </div>
//           <div className="text-right">
//             <p className="text-sm text-gray-100">Today's Tickets</p>
//             <span
//               className={`text-lg font-semibold ${
//                 counts?.counts?.today?.tickets > 0
//                   ? "text-green-300"
//                   : "text-red-300"
//               }`}
//             >
//               {`+${counts?.counts?.today?.tickets}`}
//             </span>
//           </div>
//         </div>

//         <div className="flex items-center justify-between bg-gradient-to-r from-purple-500 to-pink-600 text-white shadow-lg rounded-lg p-6">
//           <div className="flex items-center">
//             <div className="flex items-center justify-center w-16 h-16 rounded-full bg-white text-3xl text-purple-600 shadow-md">
//               🎥
//             </div>
//             <div className="ml-4">
//               <h2 className="text-3xl font-bold">
//                 {counts?.counts?.total?.demos || 0}
//               </h2>
//               <p className="text-gray-200">Total Demos</p>
//             </div>
//           </div>
//           <div className="text-right">
//             <p className="text-sm text-gray-100">Today's Demos</p>
//             <span
//               className={`text-lg font-semibold ${
//                 counts?.counts?.today?.demos > 0
//                   ? "text-green-300"
//                   : "text-red-300"
//               }`}
//             >
//               {`+${counts?.counts?.today?.demos}`}
//             </span>
//           </div>
//         </div>

//         <div className="flex items-center justify-between bg-gradient-to-r from-blue-500 to-indigo-600 text-white shadow-lg rounded-lg p-6">
//           <div className="flex items-center">
//             <div className="flex items-center justify-center w-16 h-16 rounded-full bg-white text-3xl text-blue-600 shadow-md">
//               📅
//             </div>
//             <div className="ml-4">
//               <h2 className="text-3xl font-bold">
//                 {counts?.counts?.total?.scheduledDemos || 0}
//               </h2>
//               <p className="text-gray-200">Scheduled Demos</p>
//             </div>
//           </div>
//           <div className="text-right">
//             <p className="text-sm text-gray-100">Today's Schedule</p>
//             <span
//               className={`text-lg font-semibold ${
//                 counts?.counts?.today?.scheduledDemos > 0
//                   ? "text-green-300"
//                   : "text-red-300"
//               }`}
//             >
//               {`+${counts?.counts?.today?.scheduledDemos || 0}`}
//             </span>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };











import React, { useEffect, useState } from "react";
import Layout, { Container } from "../components/layout.js";
import { Link } from "react-router-dom";
import { Doughnut, Line } from "react-chartjs-2";
import { IoClose } from "react-icons/io5";
import axios from "axios";
import { getCookie } from "../config/webStorage.js";
import { apiurl } from "../config/config.js";
import { useUser } from "../config/userProvider.js";
import { motion } from "framer-motion";
import { GoDot } from "react-icons/go";

// ==================== CHART.JS REGISTRATION ====================
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Tooltip,
  Legend,
  Filler,
);
// ============================================================

// ==================== SKELETON COMPONENTS ====================

const Skeleton = ({ className = "" }) => (
  <div
    className={`animate-pulse bg-gray-200 rounded-lg ${className}`}
    style={{
      background:
        "linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%)",
      backgroundSize: "200% 100%",
      animation: "shimmer 1.5s infinite",
    }}
  />
);

// Inject shimmer keyframe once
if (
  typeof document !== "undefined" &&
  !document.getElementById("skeleton-style")
) {
  const style = document.createElement("style");
  style.id = "skeleton-style";
  style.textContent = `
    @keyframes shimmer {
      0% { background-position: 200% 0; }
      100% { background-position: -200% 0; }
    }
  `;
  document.head.appendChild(style);
}

const StatCardSkeleton = () => (
  <div className="flex justify-between items-center bg-gray-50 px-6 py-5 rounded-2xl">
    <div className="flex items-center gap-3">
      <Skeleton className="w-4 h-4 rounded-full" />
      <Skeleton className="h-4 w-32" />
    </div>
    <Skeleton className="h-10 w-20 rounded-2xl" />
  </div>
);

const StoreDetailSkeleton = ({ bgColor = "bg-gray-100" }) => (
  <div className={`${bgColor} rounded-3xl p-6`}>
    <Skeleton className="h-3 w-24 mb-3" />
    <Skeleton className="h-10 w-16" />
  </div>
);

const DoughnutSkeleton = () => (
  <div className="flex justify-center items-center w-80 h-80 mx-auto">
    <div className="relative w-64 h-64">
      <div
        className="w-full h-full rounded-full"
        style={{
          background:
            "conic-gradient(#e5e7eb 0deg, #f3f4f6 120deg, #e5e7eb 240deg, #f3f4f6 360deg)",
          animation: "shimmer 1.5s infinite",
          backgroundSize: "200% 100%",
        }}
      />
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-28 h-28 rounded-full bg-white" />
      </div>
    </div>
  </div>
);

const LineChartSkeleton = () => (
  <div className="h-[420px] flex flex-col justify-end gap-2 px-4 pb-6 pt-10">
    <div className="flex items-end gap-3 h-full">
      {[60, 85, 45, 70, 90, 55, 75, 40, 80, 65].map((h, i) => (
        <div key={i} className="flex-1 flex flex-col justify-end gap-1">
          <Skeleton
            className="w-full"
            style={{ height: `${h}%`, borderRadius: "4px 4px 0 0" }}
          />
        </div>
      ))}
    </div>
    <div className="flex gap-3">
      {[60, 85, 45, 70, 90, 55, 75, 40, 80, 65].map((_, i) => (
        <Skeleton key={i} className="flex-1 h-3" />
      ))}
    </div>
  </div>
);

const TableSkeleton = ({ rows = 5, cols = 9 }) => (
  <div className="bg-white shadow-md rounded-lg overflow-hidden">
    <div className="p-4 border-b">
      <Skeleton className="h-7 w-48" />
    </div>
    <table className="w-full">
      <thead className="bg-gray-100">
        <tr>
          {Array.from({ length: cols }).map((_, i) => (
            <th key={i} className="p-3">
              <Skeleton className="h-3 w-full" />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: rows }).map((_, row) => (
          <tr key={row} className={row % 2 === 0 ? "bg-white" : "bg-gray-50"}>
            {Array.from({ length: cols }).map((_, col) => (
              <td key={col} className="p-3">
                <Skeleton className="h-4 w-full" />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const StatsSkeleton = () => (
  <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
    {[
      "from-blue-500 to-purple-600",
      "from-green-500 to-teal-600",
      "from-red-500 to-orange-600",
      "from-purple-500 to-pink-600",
      "from-blue-500 to-indigo-600",
    ].map((gradient, i) => (
      <div
        key={i}
        className={`flex items-center justify-between bg-gradient-to-r ${gradient} text-white shadow-lg rounded-lg p-6`}
      >
        <div className="flex items-center">
          <div className="w-16 h-16 rounded-full bg-white/30 animate-pulse" />
          <div className="ml-4 space-y-2">
            <div className="h-8 w-16 bg-white/30 rounded animate-pulse" />
            <div className="h-4 w-24 bg-white/20 rounded animate-pulse" />
          </div>
        </div>
        <div className="text-right space-y-2">
          <div className="h-3 w-24 bg-white/20 rounded animate-pulse" />
          <div className="h-6 w-10 bg-white/30 rounded animate-pulse ml-auto" />
        </div>
      </div>
    ))}
  </div>
);

// ============================================================

const Dashboard = () => {
  const { userData } = useUser();
  const userType = userData?.userType;

  const [analyticsData, setAnalyticsData] = useState(null);
  const [loadingData, setLoadingData] = useState(true);

  useEffect(() => {
    const Url =
      userType === "superadmin"
        ? `${apiurl}/admin/v1/analytic/report/dashboard/superadmin/all`
        : userType === "admin"
          ? `${apiurl}/admin/v1/analytic/report/dashboard/store`
          : userType === "user"
            ? `${apiurl}/admin/v1/analytic/report/dashboard/user`
            : "";

    if (!Url) return;

    const payload = JSON.stringify({
      vendorObjId: userData?.vendorDetails?.vendorObjId,
      storeObjId: userData?.storeDetails?.storeObjId,
      userObjId: userData?._id,
    });

    axios
      .post(Url, payload, {
        headers: { "Content-Type": "application/json" },
      })
      .then((response) => {
        if (response.data.success) {
          setAnalyticsData(response.data.data);
        }
      })
      .catch((error) => console.log(error))
      .finally(() => setLoadingData(false));
  }, [userType, userData]);

  return (
    <Layout>
      {userType === "master" ? (
        <MasterDashboard />
      ) : (
        <CommonDashboard
          analyticsData={analyticsData}
          userData={userData}
          userType={userType}
          loadingData={loadingData}
        />
      )}
    </Layout>
  );
};

export default Dashboard;

// ==================== MASTER DASHBOARD ====================

const MasterDashboard = () => {
  const [reportData, setReportData] = useState({});
  const [loading, setLoading] = useState(true);
  const token = getCookie("sctoken");

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const res = await axios.get(
          `${apiurl}/admin/v1/dashboard/master/report`,
          {
            headers: { Authorization: token },
          },
        );

        if (res.data.success) {
          setReportData(res.data.data);
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    if (token) fetchReport();
  }, [token]);

  return (
    <Container overflow="overflow-scroll">
      <div className="min-h-screen bg-gray-100 p-6">
        <div className="bg-gray-100 pb-6">
          {loading ? (
            <StatsSkeleton />
          ) : (
            <StatsSection counts={reportData?.counts} />
          )}
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="col-span-2 bg-white rounded-lg shadow p-6">
            {loading ? (
              <TableSkeleton rows={5} cols={9} />
            ) : (
              <BestSellingProductsTable
                vendors={reportData?.allRecords?.vendors}
              />
            )}
          </div>
          <div className="bg-white rounded-lg shadow p-6">
            {loading ? (
              <div>
                <Skeleton className="h-6 w-36 mb-4" />
                <TableSkeleton rows={3} cols={4} />
              </div>
            ) : (
              <PopularClientsTable />
            )}
          </div>
        </div>
      </div>
    </Container>
  );
};

// ==================== COMMON DASHBOARD ====================

const CommonDashboard = ({
  analyticsData,
  userData,
  userType,
  loadingData,
}) => {
  return (
    <div className="relative overflow-y-scroll h-full p-6 bg-gray-50">
      <Dashboard1
        analyticsData={analyticsData}
        userData={userData}
        userType={userType}
        loadingData={loadingData}
      />
    </div>
  );
};

// ==================== MAIN DASHBOARD CONTENT ====================

const Dashboard1 = ({ analyticsData, userData, userType, loadingData }) => {
  const isSuperAdmin = userType === "superadmin";

  // ========== Superadmin Data (new response structure) ==========
  const allTimeData = analyticsData?.allTimeData || {};
  const allTimeReport = analyticsData?.allTimeReport || {};
  const last30DaysData = analyticsData?.last30DaysData || {};
  const last30DaysReportSuper = analyticsData?.last30DaysReport || {};

  // ========== Admin / User Data ==========
  const last30Days = analyticsData?.last30DaysReport || {};
  const last4Weeks = analyticsData?.last4WeeksReport || {};
  const last3Weeks = analyticsData?.last3WeeksReport || {};
  const last2Weeks = analyticsData?.last2WeeksReport || {};
  const last1Week = analyticsData?.last1WeekReport || {};

  // ==================== DOUGHNUT CHART ====================
  let DoughnutData;

  if (isSuperAdmin) {
    const totalUsers = allTimeData.totalUsers || 0;
    const activeUsers = allTimeData.activeUsers || 0;
    const inactiveUsers = Math.max(totalUsers - activeUsers, 0);

    DoughnutData = {
      labels: ["Inactive Users", "Active Users"],
      datasets: [
        {
          data: [inactiveUsers, activeUsers],
          backgroundColor: ["#ff6384", "#36a2eb"],
          hoverOffset: 10,
        },
      ],
    };
  } else {
    DoughnutData = {
      labels: ["Catalog Generated", "Catalog Downloaded", "WhatsApp Sent"],
      datasets: [
        {
          data: [
            last30Days.catalog_generated || 0,
            last30Days.catalog_downloaded || 0,
            last30Days.catalog_sent_whatsapp || 0,
          ],
          backgroundColor: ["#a855f7", "#3b82f6", "#ec4899"],
          hoverOffset: 10,
        },
      ],
    };
  }

  // ==================== LINE CHART ====================
  let LineChartData;

  if (isSuperAdmin) {
    // Use last30DaysReport for the "Last 30 Days Trend"
    LineChartData = {
      labels: [
        // "Orders",
        "Catalog Generated",
        "Catalog Downloaded",
        "WhatsApp Sent",
        "Email Sent",
      ],
      datasets: [
        {
          label: "Last 30 Days",
          data: [
            // last30DaysReportSuper.order_placed || 0,
            last30DaysReportSuper.catalog_generated || 0,
            last30DaysReportSuper.catalog_downloaded || 0,
            last30DaysReportSuper.catalog_sent_whatsapp || 0,
            last30DaysReportSuper.catalog_sent_email || 0,
          ],
          borderColor: "#3b82f6",
          backgroundColor: "rgba(59, 130, 246, 0.1)",
          tension: 0.4,
          fill: true,
          borderWidth: 3,
        },
      ],
    };
  } else {
    const lineLabels = [
      "1 Week Ago",
      "2 Weeks Ago",
      "3 Weeks Ago",
      "4 Weeks Ago",
      "Last 30 Days",
    ];
    LineChartData = {
      labels: lineLabels,
      datasets: [
        // {
        //   label: "Orders",
        //   data: [
        //     last1Week.order_placed || 0,
        //     last2Weeks.order_placed || 0,
        //     last3Weeks.order_placed || 0,
        //     last4Weeks.order_placed || 0,
        //     last30Days.order_placed || 0,
        //   ],
        //   borderColor: "#22c55e",
        //   backgroundColor: "rgba(34, 197, 94, 0.1)",
        //   tension: 0.4,
        //   fill: true,
        // },
        {
          label: "Catalog Generated",
          data: [
            last1Week.catalog_generated || 0,
            last2Weeks.catalog_generated || 0,
            last3Weeks.catalog_generated || 0,
            last4Weeks.catalog_generated || 0,
            last30Days.catalog_generated || 0,
          ],
          borderColor: "#a855f7",
          backgroundColor: "rgba(168, 85, 247, 0.1)",
          tension: 0.4,
          fill: true,
        },
        {
          label: "Catalog Downloaded",
          data: [
            last1Week.catalog_downloaded || 0,
            last2Weeks.catalog_downloaded || 0,
            last3Weeks.catalog_downloaded || 0,
            last4Weeks.catalog_downloaded || 0,
            last30Days.catalog_downloaded || 0,
          ],
          borderColor: "#3b82f6",
          backgroundColor: "rgba(59, 130, 246, 0.1)",
          tension: 0.4,
          fill: true,
        },
        {
          label: "WhatsApp Sent",
          data: [
            last1Week.catalog_sent_whatsapp || 0,
            last2Weeks.catalog_sent_whatsapp || 0,
            last3Weeks.catalog_sent_whatsapp || 0,
            last4Weeks.catalog_sent_whatsapp || 0,
            last30Days.catalog_sent_whatsapp || 0,
          ],
          borderColor: "#ec4899",
          backgroundColor: "rgba(236, 72, 153, 0.1)",
          tension: 0.4,
          fill: true,
        },
      ],
    };
  }

  return (
    <div className="max-w-7xl mx-auto">
      {/* Logo Warning */}
      {!loadingData &&
        isSuperAdmin &&
        userData?.vendorDetails?.logo?.upload === false && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-red-50 border border-red-200 text-red-700 px-6 py-4 rounded-2xl mb-6 flex items-center justify-between"
          >
            <div className="flex items-center gap-3">
              <IoClose className="text-2xl" />
              <span className="font-medium">
                Logo is mandatory. Please upload your vendor logo first.
              </span>
            </div>
            <Link to="/settings/documents">
              <button className="bg-red-600 text-white px-6 py-2.5 rounded-xl text-sm font-medium hover:bg-red-700 transition">
                Upload Logo
              </button>
            </Link>
          </motion.div>
        )}

      <div className="grid grid-cols-1 xl:grid-cols-12 gap-6">
        {/* LEFT COLUMN */}
        <div className="xl:col-span-5 space-y-6">
          {/* Summary Stats Card */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-3xl shadow-sm p-8"
          >
            {loadingData ? (
              <>
                <Skeleton className="h-7 w-56 mb-8" />
                <div className="space-y-5">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <StatCardSkeleton key={i} />
                  ))}
                </div>
              </>
            ) : (
              <>
                <h2 className="text-2xl font-semibold mb-8">
                  {isSuperAdmin
                    ? "Overall Summary (All Time)"
                    : "Last 30 Days Performance"}
                </h2>
                <div className="space-y-5">
                  {/* <StatCard
                    label="Orders Placed"
                    value={
                      isSuperAdmin
                        ? allTimeReport.order_placed
                        : last30Days.order_placed
                    }
                    color="bg-emerald-100 text-emerald-700"
                  /> */}
                  <StatCard
                    label="Catalog Generated"
                    value={
                      isSuperAdmin
                        ? allTimeReport.catalog_generated
                        : last30Days.catalog_generated
                    }
                    color="bg-violet-100 text-violet-700"
                  />
                  <StatCard
                    label="Catalog Downloaded"
                    value={
                      isSuperAdmin
                        ? allTimeReport.catalog_downloaded
                        : last30Days.catalog_downloaded
                    }
                    color="bg-blue-100 text-blue-700"
                  />
                  <StatCard
                    label="WhatsApp Sent"
                    value={
                      isSuperAdmin
                        ? allTimeReport.catalog_sent_whatsapp
                        : last30Days.catalog_sent_whatsapp
                    }
                    color="bg-pink-100 text-pink-700"
                  />
                  <StatCard
                    label="Email Sent"
                    value={
                      isSuperAdmin
                        ? allTimeReport.catalog_sent_email
                        : last30Days.catalog_sent_email
                    }
                    color="bg-amber-100 text-amber-700"
                  />
                </div>
              </>
            )}
          </motion.div>

          {/* Doughnut Chart */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-3xl shadow-sm p-8"
          >
            {loadingData ? (
              <>
                <Skeleton className="h-6 w-44 mb-6" />
                <DoughnutSkeleton />
              </>
            ) : (
              <>
                <h3 className="text-xl font-semibold mb-6">
                  {isSuperAdmin
                    ? "User Activity Distribution"
                    : "Activity Distribution"}
                </h3>
                <div className="flex justify-center">
                  <div className="w-80 h-80">
                    <Doughnut data={DoughnutData} />
                  </div>
                </div>
              </>
            )}
          </motion.div>
        </div>

        {/* RIGHT COLUMN */}
        <div className="xl:col-span-7 space-y-6">
          {/* Analytics Grid */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-3xl shadow-sm p-8"
          >
            {loadingData ? (
              <>
                <Skeleton className="h-7 w-48 mb-8" />
                <div className="grid grid-cols-2 md:grid-cols-3 gap-5">
                  {[
                    "bg-[#E9CFFC]",
                    "bg-[#D0C2E3]",
                    "bg-[#C3EFD3]",
                    "bg-[#FFFDC7]",
                    "bg-[#C6E3F3]",
                    "bg-[#E9CFFC]",
                  ].map((bg, i) => (
                    <StoreDetailSkeleton key={i} bgColor={bg} />
                  ))}
                </div>
              </>
            ) : (
              <>
                <h2 className="text-2xl font-semibold mb-8">
                  {isSuperAdmin ? "All Time Analytics" : "Store Analytics"}
                </h2>
                <AnalyticsDashboard
                  analyticsData={analyticsData}
                  userType={userType}
                />
              </>
            )}
          </motion.div>

          {/* Last 30 Days Analytics (Superadmin only) */}
          {isSuperAdmin && !loadingData && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="bg-white rounded-3xl shadow-sm p-8"
            >
              <h2 className="text-2xl font-semibold mb-8">
                Last 30 Days Analytics
              </h2>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-5">
                <StoreDetails
                  title="Total Users"
                  value={last30DaysData.totalUsers || 0}
                  bgColor="bg-[#E9CFFC]"
                />
                <StoreDetails
                  title="Active Users"
                  value={last30DaysData.activeUsers || 0}
                  bgColor="bg-[#D0C2E3]"
                />
                <StoreDetails
                  title="Total Stores"
                  value={last30DaysData.totalStores || 0}
                  bgColor="bg-[#C3EFD3]"
                />
                <StoreDetails
                  title="Total Products"
                  value={last30DaysData.totalProducts || 0}
                  bgColor="bg-[#FFFDC7]"
                />
                {/* <StoreDetails
                  title="Orders Placed"
                  value={last30DaysReportSuper.order_placed || 0}
                  bgColor="bg-[#C6E3F3]"
                /> */}
                <StoreDetails
                  title="Catalog Generated"
                  value={last30DaysReportSuper.catalog_generated || 0}
                  bgColor="bg-[#E9CFFC]"
                />
                <StoreDetails
                  title="Catalog Downloaded"
                  value={last30DaysReportSuper.catalog_downloaded || 0}
                  bgColor="bg-[#C6E3F3]"
                />
                <StoreDetails
                  title="WhatsApp Sent"
                  value={last30DaysReportSuper.catalog_sent_whatsapp || 0}
                  bgColor="bg-[#C3EFD3]"
                />
                <StoreDetails
                  title="Email Sent"
                  value={last30DaysReportSuper.catalog_sent_email || 0}
                  bgColor="bg-[#D0C2E3]"
                />
              </div>
            </motion.div>
          )}

          {/* Line Chart */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-3xl shadow-sm p-8"
          >
            {loadingData ? (
              <>
                <Skeleton className="h-7 w-52 mb-8" />
                <LineChartSkeleton />
              </>
            ) : (
              <>
                <h2 className="text-2xl font-semibold mb-8">
                  {isSuperAdmin
                    ? "Last 30 Days Trend"
                    : "Weekly Activity Trend"}
                </h2>
                <div className="h-[420px]">
                  <Line
                    data={LineChartData}
                    options={{
                      responsive: true,
                      maintainAspectRatio: false,
                      plugins: {
                        legend: { position: "top", align: "end" },
                      },
                      scales: {
                        y: { beginAtZero: true, grid: { color: "#f1f5f9" } },
                        x: { grid: { color: "#f1f5f9" } },
                      },
                    }}
                  />
                </div>
              </>
            )}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

// ==================== HELPER COMPONENTS ====================

const StatCard = ({ label, value = 0, color }) => (
  <div className="flex justify-between items-center bg-gray-50 px-6 py-5 rounded-2xl">
    <p className="font-medium text-gray-700 flex items-center gap-3">
      <GoDot className="text-gray-400" /> {label}
    </p>
    <p className={`font-bold text-3xl px-6 py-1 rounded-2xl ${color}`}>
      {(value || 0).toLocaleString()}
    </p>
  </div>
);

const AnalyticsDashboard = ({ analyticsData, userType }) => {
  const isSuperAdmin = userType === "superadmin";
  const data = isSuperAdmin ? analyticsData?.allTimeData || {} : {};
  const report = isSuperAdmin
    ? analyticsData?.allTimeReport || {}
    : analyticsData?.last30DaysReport || {};

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-5">
      {isSuperAdmin && (
        <>
          <StoreDetails
            title="Total Users"
            value={data.totalUsers || 0}
            bgColor="bg-[#E9CFFC]"
          />
          <StoreDetails
            title="Active Users"
            value={data.activeUsers || 0}
            bgColor="bg-[#D0C2E3]"
          />
          <StoreDetails
            title="Total Stores"
            value={data.totalStores || 0}
            bgColor="bg-[#C3EFD3]"
          />
          <StoreDetails
            title="Total Products"
            value={data.totalProducts || 0}
            bgColor="bg-[#FFFDC7]"
          />
        </>
      )}
      {/* <StoreDetails
        title="Orders Placed"
        value={report.order_placed || 0}
        bgColor="bg-[#C6E3F3]"
      /> */}
      <StoreDetails
        title="Catalog Generated"
        value={report.catalog_generated || 0}
        bgColor="bg-[#E9CFFC]"
      />
      <StoreDetails
        title="Catalog Downloaded"
        value={report.catalog_downloaded || 0}
        bgColor="bg-[#C6E3F3]"
      />
      <StoreDetails
        title="WhatsApp Sent"
        value={report.catalog_sent_whatsapp || 0}
        bgColor="bg-[#C3EFD3]"
      />
      <StoreDetails
        title="Email Sent"
        value={report.catalog_sent_email || 0}
        bgColor="bg-[#D0C2E3]"
      />
    </div>
  );
};

const StoreDetails = ({ title, value, bgColor }) => (
  <div className={`${bgColor} rounded-3xl p-6`}>
    <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>
    <p className="text-4xl font-bold text-gray-800">
      {(value || 0).toLocaleString()}
    </p>
  </div>
);

// ==================== UNCHANGED COMPONENTS ====================

const BestSellingProductsTable = ({ vendors }) => {
  return (
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <h2 className="text-2xl font-bold text-gray-800 p-4 border-b">
        Best Selling Products
      </h2>
      <table className="w-full text-left table-auto border-collapse">
        <thead className="bg-gray-100 text-gray-600 uppercase text-sm leading-normal">
          <tr>
            <th className="p-3 border-b">ID</th>
            <th className="p-3 border-b">Product</th>
            <th className="p-3 border-b">Category</th>
            <th className="p-3 border-b">Brand</th>
            <th className="p-3 border-b">Price</th>
            <th className="p-3 border-b">Stock</th>
            <th className="p-3 border-b">Rating</th>
            <th className="p-3 border-b">Orders</th>
            <th className="p-3 border-b">Sales</th>
          </tr>
        </thead>
        <tbody>
          {vendors?.map((product, index) => (
            <tr
              key={index}
              className={`text-gray-700 hover:bg-gray-50 ${
                index % 2 === 0 ? "bg-white" : "bg-gray-50"
              }`}
            >
              <td className="p-3 border-b">{product.id}</td>
              <td className="p-3 border-b font-medium">{product.product}</td>
              <td className="p-3 border-b">{product.category}</td>
              <td className="p-3 border-b">{product.brand}</td>
              <td className="p-3 border-b">{product.price}</td>
              <td className="p-3 border-b">{product.stock}</td>
              <td className="p-3 border-b">{product.rating}</td>
              <td className="p-3 border-b">{product.orders}</td>
              <td className="p-3 border-b">{product.sales}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const PopularClientsTable = () => {
  const clients = [
    { id: "#4564", name: "Theresa Webb", orders: 300, amount: "$6500" },
  ];
  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Popular Clients</h2>
      <table className="w-full text-left border-collapse">
        <thead>
          <tr className="border-b">
            <th className="p-2">ID</th>
            <th className="p-2">CLIENT NAME</th>
            <th className="p-2">ORDER</th>
            <th className="p-2">AMOUNT</th>
          </tr>
        </thead>
        <tbody>
          {clients.map((client, index) => (
            <tr key={index} className="border-b">
              <td className="p-2">{client.id}</td>
              <td className="p-2">{client.name}</td>
              <td className="p-2">{client.orders}</td>
              <td className="p-2">{client.amount}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const StatsSection = (counts) => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="flex items-center justify-between bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg rounded-lg p-6">
          <div className="flex items-center">
            <div className="flex items-center justify-center w-16 h-16 rounded-full bg-white text-3xl text-blue-600 shadow-md">
              🛍️
            </div>
            <div className="ml-4">
              <h2 className="text-3xl font-bold">
                {counts?.counts?.total?.vendors || 0}
              </h2>
              <p className="text-gray-200">Total Vendors</p>
            </div>
          </div>
          <div className="text-right">
            <p className="text-sm text-gray-100">Today's New Vendors</p>
            <span
              className={`text-lg font-semibold ${
                counts?.counts?.today?.vendors > 0
                  ? "text-green-300"
                  : "text-red-300"
              }`}
            >
              {`+${counts?.counts?.today?.vendors || 0}`}
            </span>
          </div>
        </div>

        <div className="flex items-center justify-between bg-gradient-to-r from-green-500 to-teal-600 text-white shadow-lg rounded-lg p-6">
          <div className="flex items-center">
            <div className="flex items-center justify-center w-16 h-16 rounded-full bg-white text-3xl text-green-600 shadow-md">
              📦
            </div>
            <div className="ml-4">
              <h2 className="text-3xl font-bold">
                {counts?.counts?.total?.orders || 0}
              </h2>
              <p className="text-gray-200">Total Orders</p>
            </div>
          </div>
          <div className="text-right">
            <p className="text-sm text-gray-100">Today's Orders</p>
            <span
              className={`text-lg font-semibold ${
                counts?.counts?.today?.orders > 0
                  ? "text-green-300"
                  : "text-red-300"
              }`}
            >
              {`+${counts?.counts?.today?.orders || 0}`}
            </span>
          </div>
        </div>

        <div className="flex items-center justify-between bg-gradient-to-r from-red-500 to-orange-600 text-white shadow-lg rounded-lg p-6">
          <div className="flex items-center">
            <div className="flex items-center justify-center w-16 h-16 rounded-full bg-white text-3xl text-red-600 shadow-md">
              🎫
            </div>
            <div className="ml-4">
              <h2 className="text-3xl font-bold">
                {counts?.counts?.total?.tickets || 0}
              </h2>
              <p className="text-gray-200">Total Tickets</p>
            </div>
          </div>
          <div className="text-right">
            <p className="text-sm text-gray-100">Today's Tickets</p>
            <span
              className={`text-lg font-semibold ${
                counts?.counts?.today?.tickets > 0
                  ? "text-green-300"
                  : "text-red-300"
              }`}
            >
              {`+${counts?.counts?.today?.tickets || 0}`}
            </span>
          </div>
        </div>

        <div className="flex items-center justify-between bg-gradient-to-r from-purple-500 to-pink-600 text-white shadow-lg rounded-lg p-6">
          <div className="flex items-center">
            <div className="flex items-center justify-center w-16 h-16 rounded-full bg-white text-3xl text-purple-600 shadow-md">
              🎥
            </div>
            <div className="ml-4">
              <h2 className="text-3xl font-bold">
                {counts?.counts?.total?.demos || 0}
              </h2>
              <p className="text-gray-200">Total Demos</p>
            </div>
          </div>
          <div className="text-right">
            <p className="text-sm text-gray-100">Today's Demos</p>
            <span
              className={`text-lg font-semibold ${
                counts?.counts?.today?.demos > 0
                  ? "text-green-300"
                  : "text-red-300"
              }`}
            >
              {`+${counts?.counts?.today?.demos || 0}`}
            </span>
          </div>
        </div>

        <div className="flex items-center justify-between bg-gradient-to-r from-blue-500 to-indigo-600 text-white shadow-lg rounded-lg p-6">
          <div className="flex items-center">
            <div className="flex items-center justify-center w-16 h-16 rounded-full bg-white text-3xl text-blue-600 shadow-md">
              📅
            </div>
            <div className="ml-4">
              <h2 className="text-3xl font-bold">
                {counts?.counts?.total?.scheduledDemos || 0}
              </h2>
              <p className="text-gray-200">Scheduled Demos</p>
            </div>
          </div>
          <div className="text-right">
            <p className="text-sm text-gray-100">Today's Schedule</p>
            <span
              className={`text-lg font-semibold ${
                counts?.counts?.today?.scheduledDemos > 0
                  ? "text-green-300"
                  : "text-red-300"
              }`}
            >
              {`+${counts?.counts?.today?.scheduledDemos || 0}`}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};